import React, { useEffect } from 'react';

import {
  Paper,
  Grid,
  Box,
  Typography,
  AppBar,
  Tabs,
  Tab,
  Fab,
  Dialog,
  DialogContent,
  Toolbar,
  IconButton,
  useMediaQuery,
  useTheme,
  DialogActions,
  Snackbar,
  CircularProgress,
  Button,
  makeStyles,
  DialogTitle,
  DialogContentText,
  TextField,
  withStyles,
  Drawer,
  Card,
  Input,
  InputAdornment,
  Tooltip,
  Link,
} from '@material-ui/core';
import clsx from 'clsx';
import moment from 'moment';
import {
  getBounds,
  getCoords,
  getMapCenter,
  getMarker,
} from 'services/Geolocation';

import SpeedDial from '@material-ui/lab/SpeedDial';
import SpeedDialIcon from '@material-ui/lab/SpeedDialIcon';
import SpeedDialAction from '@material-ui/lab/SpeedDialAction';
import CloseIcon from '@material-ui/icons/Close';

import MainScreen from 'components/MainScreen';

import { CardWidget } from './CardWidgets';
import { SectionWidget } from './SectionWidgets';
import { fetchDynamicJSON } from 'services/dynamicjson';
import { deeplinkToURL, processDeeplink } from 'services/deeplink';
import { useParams, useLocation, useHistory } from 'react-router-dom';
import DynamicIcon, { FileTypeIcons } from 'components/Common/DynamicIcon';
import InfiniteScroll from 'react-infinite-scroller';
import { TableWidget } from 'components/DynamicScreen/TableWidget/index';

import { getDirect } from 'services/api';
import {
  fetchChatRoom,
  emitter,
  sendMessage,
  fetchMoreFromChatRoom,
} from 'services/chat';
import { useAuthUserContext } from 'context/AuthContext';

import { sectionSpecificStyles } from './sectionsStyle';
import { FormControl } from 'util/FormControl';
import { get, isEmpty } from 'lodash';
import { arrayIncludes } from '@material-ui/pickers/_helpers/utils';
import Linkify from 'linkifyjs/react';
import { textFormatter } from 'util/string';
import SMDIalogControl, {
  SMChatDIalogControl,
  SMConfirmDialogControl,
  SMLocationDIalogControl,
  SMPromptControl,
} from 'services/SMDialogControl';
import { getGradient } from './CardWidgets/BasicWidgets';
import {
  CloudUpload,
  KeyboardArrowDown,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  KeyboardArrowUp,
  RemoveCircle,
  SearchOutlined,
  Send,
  Visibility,
  VisibilityOff,
} from '@material-ui/icons';
import AddIcon from '@material-ui/icons/Add';
import LocationSelector from 'components/Common/LocationPicker';
import MapComponent from 'components/Common/MapContainer';
import { uploadFile } from 'services/files';
import getDialogSize from 'util/SizeControl';
import config from 'config';
import ChatRoomUI from 'components/Chat/ChatRoomUI';
import { sendAmplitudeData } from 'util/amplitude';
import { ErrorBlock } from './Error';
import { clickToPrint } from 'util/misc';
import { persistentStore } from 'services/storage';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    position: 'relative',
  },
  mainContainer: {
    overflow: 'auto',
    maxWidth: 'calc(100vw - 80px)',
    height: '100%',
    // [theme.breakpoints.up('md')]: {
    //   width: '90%',
    //   margin: 'auto'
    // },
    // [theme.breakpoints.down('md')]: {
    //   width: '100%'
    // }
  },
  magicContainer: {
    overflow: 'auto',
    width: '100%',
  },
  magicScreenContainer: {
    overflow: 'auto',
    maxWidth: '700px',
    height: '100%',
    margin: '0px auto',
  },
  gridContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  paper: {
    color: theme.palette.text.secondary,
    background: '#ffffffff',
    boxShadow: '0px 2.5px 20px #0000002d',
    margin: '50px 100px 50px 100px',
    borderRadius: '5px',
  },
  scrollable: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    overflowX: 'visible',
    overflowY: 'visible',
  },
  viewContainer: {
    flex: '1 1 auto',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  titlebar: {
    background: theme.palette.background.paper,
    color: theme.palette.text.secondary,
    backgroundColor: '#ffffff',
    boxShadow: 'none',
    borderBottom: '1px solid #e5e5e5',
  },
  fab: {
    position: 'absolute',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
  speedDial: {
    position: 'absolute',
    right: theme.spacing(2),
    '&.MuiSpeedDial-directionUp': {
      bottom: theme.spacing(2),
    },
    '&.MuiSpeedDial-directionLeft': {
      top: theme.spacing(2),
    },
  },
  contents: {
    padding: theme.spacing(2),
  },
  tabsIndicator: {
    backgroundColor: '#233C97',
    height: 5,
  },
  tabsContainer: {
    display: 'grid',
    gridAutoFlow: 'column',
    gridGap: theme.spacing(5),
    minHeight: 64,
  },
  tab: {
    color: '#747474',
    minWidth: 100,
    padding: 0,
    fontSize: 16,
  },
  selectedTab: {
    fontWeight: 700,
    color: '#233C97',
  },
  dialogToolBar: {
    minWidth: '500px',
    display: 'flex',
    flex: 1,
    justifyContent: 'space-between',
    padding: '0px',
    backgroundColor: '#ffffff',
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
  },
  dialog: {
    borderRadius: '0px',
    right: 0,
  },
  cardTabsContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    overflowX: 'auto',
    padding: 15,
    position: 'relative',
  },
  dialogContent: {
    padding: 0,
    minHeight: '300px',
  },
  dialogActions: {
    margin: theme.spacing(0, 3),
    padding: theme.spacing(2, 0),
    borderTop: '1px solid #b5b5b5',
  },
  dialogTitle: {
    paddingLeft: theme.spacing(1.5),
  },
  drawer: {
    width: 400,
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  drawerOpen: {
    width: 400,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: 0,
  },
  botContent: {
    display: 'flex',
    alignItems: 'flex-start',
    minHeight: 'calc(100% - 70px)',
    maxWidth: '100%',
  },
  iconRippleLess: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  colorPrimary: {
    color: '#3d65fe',
  },
  botMessageField: {
    '&::-webkit-scrollbar': {
      width: '10px',
      borderRadius: 5,
    },
    '&::-webkit-scrollbar-track': {
      background: '#f1f1f1',
    },

    '&::-webkit-scrollbar-thumb': {
      background: '#888888',
      borderRadius: 5,
    },
    padding: 20,
  },
}));

const CssTextField = withStyles({
  root: {
    '& label.Mui-focused': {
      color: '#2896E9',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#2896E9',
    },
  },
})(TextField);

const LoadingSheet = (props) => {
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        backgroundColor: '#ffffff00',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        ...(props.containerStyle || {}),
      }}
    >
      <CircularProgress />
    </div>
  );
};

export const PreviewSidebar = ({ preview, rows }) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(true);
  const [isCollapse, setIsCollapse] = React.useState(false);

  return !isCollapse ? (
    <Drawer
      variant="permanent"
      anchor="right"
      open={open}
      className={clsx(classes.drawer, {
        [classes.drawerOpen]: open,
        [classes.drawerClose]: !open,
      })}
      classes={{
        paper: clsx({
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        }),
      }}
    >
      <Toolbar />
      <Box p={2}>
        <Box display="flex" justifyContent="flex-end">
          <IconButton
            onClick={() => {
              setOpen(false);
              setTimeout(() => {
                setIsCollapse(true);
              }, 200);
            }}
          >
            <DynamicIcon iconId={156} />
          </IconButton>
        </Box>
        <Typography
          variant="h5"
          style={{ marginBottom: 16, paddingLeft: 8, fontWeight: 700 }}
        >
          {preview.title}
        </Typography>
        <Box overflow="auto">
          {rows.map((row, index) => {
            return (
              <Box
                px={2}
                my={2}
                border="1px solid #e8e8e8"
                borderRadius="5px"
                width="100%"
              >
                <Box display="flex" py={2} borderBottom="1px solid #e8e8e8">
                  <Typography style={{ marginRight: 16 }}>
                    {index + 1}.
                  </Typography>
                  <Typography
                    style={{
                      wordWrap: 'break-word',
                      overflow: 'hidden',
                      whiteSpace: 'pre-wrap',
                    }}
                  >
                    {row[preview.titleKey].value}
                  </Typography>
                </Box>
                <Box display="flex" py={2}>
                  {row[preview.contentKey].choices ? (
                    row[preview.contentKey].choices.map((option, index) => (
                      <Button
                        key={index}
                        variant="outlined"
                        style={{
                          marginRight: 16,
                        }}
                      >
                        {option.title}
                      </Button>
                    ))
                  ) : (
                    <TextField size="small" variant="outlined" fullWidth />
                  )}
                </Box>
              </Box>
            );
          })}
        </Box>
      </Box>
    </Drawer>
  ) : (
    <Box
      display="flex"
      justifyContent="start"
      alignItems="flex-end"
      flexDirection="column"
    >
      <Toolbar />
      <IconButton
        onClick={() => {
          setIsCollapse(false);
          setTimeout(() => {
            setOpen(true);
          }, 100);
        }}
        style={{
          marginTop: 24,
          borderRadius: '16px 0px 0px 16px',
          border: '1px solid #e8e8e8',
        }}
      >
        <DynamicIcon iconId={157} />
      </IconButton>
    </Box>
  );
};

function FormControls({ formControls, handleDeeplink }) {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: 20,
      }}
    >
      {(formControls || []).map((control, index) => (
        <Button
          onClick={() => handleDeeplink(control.deep_link, control.apiType)}
          style={{
            background: 'transparent',
            color: '#505050',
            fontSize: '1.3rem',
          }}
          {...(index < formControls.length / 2
            ? {
                startIcon: (
                  <DynamicIcon
                    iconId={control.iconId}
                    style={{ height: 12.5, width: 12.5, marginTop: -3 }}
                  />
                ),
              }
            : {
                endIcon: (
                  <DynamicIcon
                    iconId={control.iconId}
                    style={{ height: 12.5, width: 12.5, marginTop: -3 }}
                  />
                ),
              })}
        >
          {(control.title || '').toUpperCase()}
        </Button>
      ))}
    </div>
  );
}

function Section({
  type,
  section,
  content,
  handleDeeplink,
  setDialogDeeplink,
  setDeepLink,
  overrideHandleDeepLink,
  setMessage,
  rightSideBar,
  baseDeeplink,
  interpolateSections,
  index,
  insideDialog,
  insideChat,
  ...props
}) {
  const [sectionData, setSectionData] = React.useState({});
  const [selectedCards, setSelectedCard] = React.useState([]);
  const [formData, setFormData] = React.useState({});
  const formHandlers = FormControl(formData, setFormData);
  const [cards, setCards] = React.useState(section.cards || []);
  const [tables, setTables] = React.useState(section.tables || []);
  const [renderCards, setRenderCards] = React.useState(cards || []);
  const [searchString, setSearchString] = React.useState('');
  const [currentDeeplink, setCurrentDeeplink] = React.useState(undefined);

  const fetchContent = (deeplink) => {
    handleDeeplink(deeplink, 1).then((data) => {
      data && setCards(get(data, ['sections', 0, 'cards']));
      data && setTables(get(data, ['sections', 0, 'tables']));
    });
  };

  React.useEffect(() => {
    if (currentDeeplink) {
      fetchContent(currentDeeplink);
    }
  }, [currentDeeplink]);

  React.useEffect(() => {
    setCards(section.cards);
  }, [section.cards]);

  React.useEffect(() => {
    setTables(section.tables);
  }, [section.tables]);

  React.useEffect(() => {
    setSectionData(section);
  }, [section]);

  const handleSelect = (id) => {
    let updatedSelectedCards = [];

    if (selectedCards.includes(id)) {
      updatedSelectedCards = selectedCards.filter(
        (selectedValue) => selectedValue !== id
      );
    } else {
      updatedSelectedCards = [...selectedCards, id];
    }
    setSelectedCard(updatedSelectedCards);
  };

  const handleUpdateSection = (deeplink) => {
    const convertedDeeplink = deeplinkToURL(deeplink);

    // apipost(convertedDepplink, {body: {selectedCards}})
    getDirect(convertedDeeplink).then((response) => {
      try {
        response.data &&
          response.data.refreshDeeplink &&
          setDeepLink(response.data.refreshDeeplink);
        if (response.error) throw response.error;
      } catch (err) {
        err.userMessage
          ? props.setMessage(err.userMessage)
          : props.setMessage('Something Went Wrong!');
      }
    });
  };

  React.useEffect(() => {
    if (!!searchString) {
      setRenderCards([
        ...cards.filter((card) =>
          new RegExp((searchString || '').toLowerCase()).test(
            (card.searchString || '').toLowerCase()
          )
        ),
      ]);
    } else {
      setRenderCards(cards);
    }
  }, [searchString, cards]);

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
        }}
      >
        <SectionWidget
          {...sectionData}
          handleDeeplink={(deeplink, apiType, formBody) => {
            return handleDeeplink(deeplink, apiType, formBody, {
              doneCallback: (refreshDeeplink) => {
                setDeepLink(refreshDeeplink);
                SMDIalogControl.close();
                SMConfirmDialogControl.close();
              },
            }).then(
              (response) =>
                response &&
                response.refreshDeeplink &&
                setDeepLink(response.refreshDeeplink)
            );
          }}
          setCurrentDeeplink={setCurrentDeeplink}
          currentDeeplink={currentDeeplink}
          onChange={setDeepLink}
          insideDialog={insideDialog}
          otherProps={{ ...props, handleUpdateSection, selectedCards }}
        />
        {(cards || []).length > 0 &&
          (cards || []).reduce(
            (searchAvailable, currentCard) =>
              searchAvailable || !!currentCard.searchString,
            false
          ) && (
            <CssTextField
              placeholder="Search"
              variant="outlined"
              size="small"
              onChange={(e) => setSearchString(e.target.value)}
              style={{ padding: 8 }}
              InputProps={{
                disableUnderline: true,
                startAdornment: (
                  <InputAdornment>
                    <SearchOutlined style={{ color: '#949494' }} />
                  </InputAdornment>
                ),
              }}
            />
          )}
      </div>
      {renderCards &&
        (renderCards.length ? (
          <div
            style={{
              ...((sectionSpecificStyles[sectionData.type] || {})
                .sectionStyle || {}),
            }}
          >
            {renderCards.map((card, index) => (
              <CardCompopnent
                responseAwaited={props.responseAwaited}
                setResponseAwaited={props.setResponseAwaited}
                key={`card-${card.id || index}`}
                {...props}
                {...card}
                {...{
                  handleSelect,
                  handleDeeplink,
                  setDeepLink,
                  overrideHandleDeepLink,
                  interpolateSections,
                  sectionData,
                  setMessage,
                  insideChat,
                  insideDialog,
                  sectionIndex: index,
                  ...(section.request ? { ...formHandlers, formData } : {}),
                }}
              />
            ))}
          </div>
        ) : (
          !tables && <NoData dataType="cards" />
        ))}
      {tables && (
        <div>
          {tables.map((table, index) => (
            <TableWidget
              setDeepLink={setDeepLink}
              setTables={setTables}
              key={`table-${table.id || index}`}
              {...{
                ...props,
                handleDeeplink,
                ...(section.request ? { ...formHandlers, formData } : {}),
              }}
              {...table}
              insideDialog={insideDialog}
              rightSideBar={rightSideBar}
              setMessage={setMessage}
              setDialogDeeplink={setDialogDeeplink}
            />
          ))}
        </div>
      )}
      {section.formControls && (
        <FormControls
          formControls={section.formControls}
          handleDeeplink={handleDeeplink}
        />
      )}
    </>
  );
}

function CardCompopnent({
  id,
  content,
  sectionData,
  insideChat,
  insideDialog,
  ...props
}) {
  const cleanProps = (props) => ({
    ...props,
    _key: props.key,
    _ref: props.ref,
  });

  return (
    <>
      {content
        ? content.map((widgetProps, index) => {
            return (
              <div
                key={index}
                style={{
                  ...(sectionData
                    ? (
                        (sectionSpecificStyles[sectionData.type] || {})[
                          'cardStyle'
                        ] || (() => {})
                      )(widgetProps.card_content_type)
                    : {}),
                }}
              >
                <CardWidget
                  responseAwaited={props.responseAwaited}
                  setResponseAwaited={props.setResponseAwaited}
                  key={`card-widget-${id}-${index}`}
                  parent={{ id, content }}
                  {...cleanProps(widgetProps)}
                  {...props}
                  insideCard={true}
                  index={index}
                  insideDialog={insideDialog}
                />
              </div>
            );
          })
        : null}
    </>
  );
}

function LinkFab({ title, deep_link, iconId, handleDeeplink }) {
  const classes = useStyles();
  return (
    <Fab
      color="primary"
      className={classes.fab}
      aria-label={title}
      onClick={() => handleDeeplink(deep_link)}
    >
      <DynamicIcon
        insideColoredButton
        style={{ color: '#ffffff' }}
        iconId={iconId}
        title={title}
      />
    </Fab>
  );
}

function LinkSpeedDial({ fabs, direction, handleDeeplink }) {
  const [open, setOpen] = React.useState(false);
  const classes = useStyles();

  return (
    fabs && (
      <SpeedDial
        ariaLabel=""
        className={classes.speedDial}
        icon={<SpeedDialIcon />}
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        open={open}
        direction={direction || 'up'}
      >
        {fabs.map(({ title, iconId, deep_link }) => (
          <SpeedDialAction
            key={title}
            icon={
              <DynamicIcon
                insideColoredButton
                style={{ color: '#ffffff' }}
                iconId={iconId}
                title={title}
              />
            }
            tooltipTitle={title}
            onClick={() => handleDeeplink(deep_link)}
          />
        ))}
      </SpeedDial>
    )
  );
}

function DynamicFab({ fabs, ...props }) {
  if (fabs && fabs.length === 1) {
    return <LinkFab {...fabs[0]} {...props} />;
  }

  return fabs && <LinkSpeedDial fabs={fabs} {...props} />;
}

function NoData({ dataType }) {
  const classes = useStyles();
  return (
    <Card className={classes.paper}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        padding={10}
      >
        <Typography>No {dataType}</Typography>
      </Box>
    </Card>
  );
}

function DynamicIconActions(props) {
  const {
    icons,
    formData,
    handleDeeplink,
    dialogActionFunctionality,
    resetFormState,
  } = props;

  const handleClick = (button) => {
    if (button.apiType === 1) {
      dialogActionFunctionality({ refreshDeeplink: button.deep_link });
    } else {
      handleDeeplink(button.deep_link, button.apiType, formData).then(
        (response) => {
          dialogActionFunctionality(response || {});
          (resetFormState || (() => {}))();
        }
      );
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        flex: 1,
        alignItems: 'center',
        justifyContent: 'flex-end',
      }}
    >
      {icons &&
        icons.map((icon, index) => (
          <Button
            key={icon.title || index}
            tooltipTitle={icon.title}
            onClick={() => handleClick(icon)}
            style={{
              display: 'flex',
              alignItems: 'center',
              cursor: 'pointer',
              margin: 10,
              background:
                'transparent linear-gradient(240deg, #7467F0 0%, #2896E9 100%) 0% 0% no-repeat padding-box',
              color: '#ffffff',
              padding: '5px 15px 5px 15px',
              fontWeight: 'bold',
            }}
          >
            <DynamicIcon
              insideColoredButton
              iconId={icon.iconId}
              title={icon.title}
              style={{
                color: '#ffffff',
              }}
            />
          </Button>
        ))}
    </div>
  );
}

function DynamicSectionsView({
  sections,
  scrollable,
  nextPageUrl,
  setDeepLink,
  setDialogDeeplink,
  overrideHandleDeepLink,
  setMessage,
  rightSideBar,
  insideDialog,
  ...props
}) {
  const classes = useStyles();
  const [sectionsData, setSectionsData] = React.useState({
    sections: sections,
    nextUrl: '',
  });

  React.useEffect(() => {
    setSectionsData({ sections, nextUrl: nextPageUrl });
  }, [sections, nextPageUrl]);

  const interpolateSections = (newSections, index, removalSectionsNumber) => {
    if (newSections) {
      setSectionsData({
        ...sectionsData,
        sections: [
          ...(sectionsData.sections.slice(0, index + 1) || []),
          ...newSections,
          ...(sectionsData.sections.slice(
            index + 1,
            sectionsData.sections.length
          ) || []),
        ],
      });
    } else {
      let tempSections = sectionsData.sections;
      tempSections.splice(index, removalSectionsNumber);
      setSectionsData({ ...sectionsData, sections: tempSections });
    }
  };

  const handleNextPage = () => {
    sectionsData.nextUrl &&
      fetchDynamicJSON(deeplinkToURL(sectionsData.nextUrl)).then((nextPage) => {
        setSectionsData({
          sections: [...sectionsData.sections, ...(nextPage.sections || [])],
          nextUrl: nextPage.nextPageUrl,
        });
      });
  };

  const renderedSections =
    sectionsData.sections &&
    sectionsData.sections.map((section, index) => (
      <Section
        key={`section-${section.id || index}`}
        index={index}
        section={section}
        {...props}
        setDeepLink={setDeepLink}
        overrideHandleDeepLink={overrideHandleDeepLink}
        rightSideBar={rightSideBar}
        interpolateSections={interpolateSections}
        setMessage={setMessage}
        insideDialog={insideDialog}
        responseAwaited={props.responseAwaited}
        setResponseAwaited={props.setResponseAwaited}
        setDialogDeeplink={setDialogDeeplink}
      />
    ));

  return !scrollable ? (
    renderedSections
  ) : (
    <div className={classes.scrollable}>
      <InfiniteScroll
        loadMore={handleNextPage}
        hasMore={sectionsData.nextUrl ? true : false}
        loader={
          <Box display="flex" justifyContent="center" p={1}>
            <CircularProgress size={25} />
          </Box>
        }
        useWindow={false}
      >
        {renderedSections}
      </InfiniteScroll>
    </div>
  );
}

const NavIcon = (props) => {
  const navIcons = {
    up: KeyboardArrowUp,
    right: KeyboardArrowRight,
    down: KeyboardArrowDown,
    left: KeyboardArrowLeft,
  };

  const RenderIcon = navIcons[(props || {}).direction || 'right'];

  return <RenderIcon style={props.style} />;
};

export function DynamicTabsView({
  tabs,
  curTabIndex,
  newTabDeeplink,
  rightSideBar,
  withoutBase,
  setMessage,
  localSetDeeplink,
  ...props
}) {
  const [selectedTabIndex, setSelectedTabIndex] = React.useState(
    curTabIndex || 0
  );
  const classes = useStyles();

  React.useEffect(() => {
    setSelectedTabIndex(curTabIndex || 0);
  }, [curTabIndex, tabs]);

  const activeTab = tabs && tabs[selectedTabIndex];

  const recordChildState = (childState) => {
    if (props.tabFormKey) {
      (props.setFormState || (() => {}))({
        [props.tabFormKey]: {
          ...props.formData[props.tabFormKey],
          [(tabs[selectedTabIndex] || {}).title]: childState,
        },
      });
    }
  };

  React.useEffect(() => {
    (props.setFormState || (() => {}))({
      [props.tabFormKey]: {
        ...((tabs || []).reduce(
          (state, currentTab) => ({ ...state, [currentTab.title]: {} }),
          {}
        ) || {}),
      },
    });
  }, [tabs]);

  const TabWrapper = withoutBase
    ? ({ children }) => children
    : ({ children }) => (
        <AppBar
          position="static"
          className={classes.titlebar}
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
          }}
        >
          {children}
        </AppBar>
      );

  return (
    <>
      {tabs && (
        <TabWrapper>
          <Tabs
            value={selectedTabIndex}
            indicatorColor="primary"
            onChange={(e, tabIndex) => setSelectedTabIndex(tabIndex)}
            variant="scrollable"
            ScrollButtonComponent={(props) => {
              return (
                <IconButton {...props}>
                  <NavIcon direction={props.direction} />
                </IconButton>
              );
            }}
          >
            {tabs.map((tab, index) => (
              <Tab
                label={tab.title}
                key={index}
                classes={{ root: classes.tab }}
                style={{
                  paddingLeft: 10,
                  paddingRight: 10,
                }}
              />
            ))}
          </Tabs>
          {!!newTabDeeplink && (
            <IconButton
              onClick={() =>
                props.handleDeeplink(
                  newTabDeeplink,
                  undefined,
                  {},
                  {
                    fallbackOperation: props.setDeepLink,
                    doneCallback: (refreshDeeplink) => {
                      props.setDeepLink(refreshDeeplink);
                      SMDIalogControl.close();
                      SMConfirmDialogControl.close();
                    },
                    errorCallback: (error) => {},
                  }
                )
              }
            >
              <AddIcon style={{ color: '#747474' }} />
            </IconButton>
          )}
        </TabWrapper>
      )}
      {activeTab && (
        <DynamicView
          deeplink={activeTab.deep_link}
          json={activeTab.tabContent}
          rightSideBar={rightSideBar}
          currentTabIndex={selectedTabIndex}
          recordChildState={recordChildState}
          stateParentCopy={
            (props.formData[props.tabFormKey] || {})[
              (tabs[selectedTabIndex] || {}).title
            ]
          }
          hideToolbar
          setMessage={setMessage}
          {...props}
        />
      )}
    </>
  );
}

function DynamicJSONPayloadRenderer({
  payload,
  childProps,
  formData,
  formHandlers,
  setCurrentDeepLink,
  handleDeeplink,
}) {
  useEffect(() => {
    payload.content.deep_link &&
      (setCurrentDeepLink || (() => {}))(payload.content.deep_link);
  }, [payload.content.deep_link]);

  return payload.content.section.map((currentSection) => (
    <Section
      overrideHandleDeepLink={true}
      setDeepLink={setCurrentDeepLink || (() => {})}
      handleDeeplink={handleDeeplink}
      formData={formData}
      insideChat={true}
      {...(childProps || {})}
      {...formHandlers}
      setFormState={(formState, deepLink, apiType) => {
        if (apiType === 1 || !apiType) {
          (setCurrentDeepLink || (() => {}))(deepLink);
        } else {
          handleDeeplink(deepLink, apiType, formState).then((response) => {
            try {
              response &&
                response.refreshDeeplink &&
                (setCurrentDeepLink || (() => {}))(response.refreshDeeplink);
              if (response && response.error) throw response.error;
            } catch (err) {
              console.log(err);
            }
          });
        }
      }}
      section={currentSection}
    />
  ));
}

function FileAttachmentPayloadRenderer({
  payload,
  childProps,
  transaction,
  comment,
}) {
  const [previewUnavailable, setPreviewUnavailable] = React.useState(false);
  const bubbleStyles = {
    received: {
      borderRadius: 15,
      borderBottomLeftRadius: 2,
      background: '#dce7ff',
      boxShadow: '20px 20px 100px #00000011',
      color: '#272b2f',
      fontSize: 17.5,
      maxWidth: 300,
    },
    sent: {
      borderRadius: 15,
      borderBottomRightRadius: 2,
      background: '#3d65fe',
      boxShadow: '20px 20px 100px #00000011',
      color: '#ffffff',
      fontSize: 17.5,
      maxWidth: 300,
      marginRight: 20,
    },
  };

  const timeStampAreaStyles = {
    received: {
      textAlign: 'right',
      color: '#787878',
      fontSize: 12,
      margin: '5px 5px 0px 15px',
    },
    sent: {
      textAlign: 'right',
      color: '#e8e8e8',
      fontSize: 12,
      margin: '5px 5px 0px 15px',
    },
  };

  return (
    <div
      style={{
        borderTopRightRadius: 15,
        borderTopLeftRadius: 15,
        overflow: 'hidden',
      }}
    >
      <div style={{ ...bubbleStyles[transaction] }}>
        <div
          style={{
            position: 'relative',
            width: 300,
            minHeight: 100,
            borderTopRadius: 15,
            overflow: 'hidden',
            position: 'relative',
            backgroundColor: '#8888ff',
            borderTopRightRadius: 15,
            borderTopLeftRadius: 15,
          }}
        >
          {/* <div
            style={{
              width: 300,
              height: 150,
              borderTopRightRadius: 15,
              borderTopLeftRadius: 15,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              background: '#e8e8e8',
            }}
          >
            <DynamicIcon iconId={909} style={{ width: 25, height: 25 }} />
          </div> */}
          <a href={payload.url} target="_blank">
            <div
              style={{
                width: 300,
                height: 100,
                paddingLeft: 10,
                display: 'flex',
                alignItems: 'center',
                position: 'absolute',
              }}
            >
              <FileTypeIcons
                type={payload.fileType}
                style={{ width: 50, height: 50 }}
              />
              <Typography
                style={{
                  color: '#ffffff',
                  maxWidth: 210,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  wordWrap: 'nowrap',
                  whiteSpace: 'nowrap',
                }}
              >
                {payload.file_name}
              </Typography>
            </div>
            <img
              src={payload.url}
              onError={(i) => {
                setPreviewUnavailable(true);
                i.target.style.display = 'none';
              }}
              style={{
                borderTopRightRadius: 15,
                borderTopLeftRadius: 15,
                position: 'absolute',
                zIndex: 1,
                width: 300,
                height: 150,
                objectFit: 'cover',
                background: 'none',
              }}
            />
          </a>
        </div>
        <div
          style={{
            padding: 10,
            width: '100%',
            maxWidth: '100%',
            ...{
              display: 'flex',
              alignItems: 'flex-end',
              flexShrink: 1,
              flexWrap: 'wrap',
            },
          }}
        >
          <Linkify
            style={{
              flexWrap: 'wrap',
              wordWrap: 'break-word',
              maxWidth: '90%',
            }}
          >
            {textFormatter(payload.caption || '')}
          </Linkify>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end',
              alignItems: 'center',
              flexGrow: 1,
            }}
          >
            <div style={timeStampAreaStyles[transaction]}>
              {moment.unix(comment.unix_timestamp).format('hh:mm a')}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const PayloadRenderer = (payloadProps) => {
  const payloadRenderers = {
    dynamicjson: (props) => <DynamicJSONPayloadRenderer {...props} />,
    file_attachment: (props) => <FileAttachmentPayloadRenderer {...props} />,
  };

  const RendererComponent =
    payloadRenderers[payloadProps.payload.type || payloadProps.comment.type];

  return RendererComponent ? (
    <RendererComponent
      {...payloadProps}
      setCurrentDeepLink={(deeplink) => {
        /^(http|https):\/\/(.+)/.test(deeplink)
          ? window.open(deeplink, '_blank')
          : payloadProps.setCurrentDeepLink(deeplink);
      }}
    />
  ) : null;
};

function OnboardingBotView({
  bot,
  rightSideBar,
  setMessage,
  handleDeeplink,
  ...props
}) {
  const user = useAuthUserContext();
  const [currentDeepLink, setCurrentDeepLink] = React.useState(
    bot.content_deep_link
  );
  const [formData, setFormData] = React.useState({});
  const formHandlers = FormControl(formData, setFormData);
  const [chatRoom, setChatRoom] = React.useState({});
  const [botMessage, setBotMessage] = React.useState('');
  const [botMessages, setBotMessages] = React.useState([]);
  const [userLastMessage, setUserLastMessage] = React.useState('');
  const [message, setUserMessage] = React.useState('');
  const [messageSent, setMessageSent] = React.useState(false);
  const [selectedFile, setSelectedFile] = React.useState(undefined);
  const [sendingMessage, setSendingMessage] = React.useState(false);
  const classes = useStyles();
  const filePicker = React.useRef({});
  const contentAreaRef = React.useRef({});

  const fetchMessages = React.useCallback((completionCallback) => {
    fetchChatRoom(bot.room_id).then((chatRoom) => {
      setChatRoom(chatRoom);
      setBotMessages(
        (chatRoom.comments || []).filter(
          (message) => message.username_real !== user.userId
        )
      );
      (completionCallback || (() => {}))();
    });
  });

  const sendFile = () => {
    uploadFile(
      selectedFile,
      () => setSendingMessage(true),
      (data, file) => {
        const newFile = data.files[0];
        const payload = {
          url: newFile.fileUrl,
          caption: message && message.trim(),
          file_name: file.name,
          file_type: file.type,
        };
        sendMessageToRoom(
          `[file] ${newFile.fileUrl} [/file]`,
          'file_attachment',
          payload
        );
      },
      (error = {}) => {
        setSendingMessage(false);
        setMessage(error.userMessage || error.errorMessage);
      }
    );
  };

  const selectFile = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const newMessageHandler = (newMessage) => {
    if ((newMessage || {}).isLast && (newMessage || {}).email !== user.userId) {
      fetchMessages(() => setUserLastMessage(''));
    }
  };

  React.useEffect(() => {
    emitter.on('new-message', newMessageHandler);
    return () => {
      emitter.off('new-message', newMessageHandler);
    };
  }, [bot.room_id]);

  React.useEffect(() => {
    fetchMessages();
  }, [bot.room_id]);

  const sendMessageToRoom = (text, type, payload) => {
    const msg = message && message.trim();
    if (msg || text) {
      setSendingMessage(true);
      sendMessage(bot.room_id, text || msg, type, payload).then((response) => {
        setUserMessage('');
        setSelectedFile(undefined);
        setSendingMessage(false);
      });
    }
  };

  const onKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      selectedFile ? sendFile() : sendMessageToRoom();
      return;
    }
  };

  return (
    <>
      <div
        style={{
          borderRadius: 10,
          padding: 35,
          backgroundColor: '#ffffff',
          boxShadow: '0px 2.5px 20px #0000002d',
          marginBottom: 25,
          minHeight: '30vh',
        }}
      >
        <div className={classes.botContent}>
          <DynamicIcon
            iconId={5}
            style={{ marginRight: 15, width: 50, height: 50, marginTop: 20 }}
          />
          <div
            style={{
              paddingLeft: '20px',
              width: '100%',
              boxSizing: 'border-box',
              maxWidth: '100%',
            }}
          >
            <div
              ref={contentAreaRef}
              style={{
                color: '#505050',
                width: '100%',
                maxHeight: '25vh',
                overflowY: 'auto',
                overflowX: 'hidden',
              }}
              className={classes.botMessageField}
            >
              {/* <Typography
                style={{
                  fontSize: "30px",
                  whiteSpace: "pre-line",
                }}
              >
                <Linkify>
                  {textFormatter(
                    ((botMessages || [])[botMessages.length - 1] || {})
                      .message || ''
                  )}
                </Linkify>
                {botMessage}
              </Typography>
              {((botMessages || [])[botMessages.length - 1] || {}).payload && (
                <PayloadRenderer
                  payload={
                    ((botMessages || [])[botMessages.length - 1] || {}).payload
                  }
                  comment={(botMessages || [])[botMessages.length - 1] || {}}
                  setCurrentDeepLink={setCurrentDeepLink}
                  {...{ formData, formHandlers, handleDeeplink }}
                />
              )}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '20px',
                }}
              >
                <DynamicIcon iconId={154} />
                <Typography style={{ paddingLeft: '20px' }}>
                  Instructions
                </Typography>
              </div>
              {userLastMessage && (
                <div
                  style={{
                    padding: 10,
                    background:
                      'transparent linear-gradient(2deg, #2896E9 0%, #7467F0 100%) 0% 0% no-repeat padding-box',
                    borderRadius: 7,
                    borderBottomRightRadius: 1,
                    backgroundColor: '#3f3e60',
                    color: '#ffffff',
                    marginLeft: 20,
                  }}
                >
                  {userLastMessage}
                </div>
              )} */}
              <ChatRoomUI
                {...props}
                user={user}
                chatRoom={chatRoom}
                formData={formData}
                formHandlers={formHandlers}
                handleDeeplink={handleDeeplink}
                setCurrentDeepLink={setCurrentDeepLink}
              />
            </div>
            <CssTextField
              id="standard-basic"
              label="Type a message for me"
              style={{ minWidth: '100%', marginTop: 50, alignSelf: 'flex-end' }}
              onKeyPress={onKeyPress}
              value={message}
              onChange={(e) => setUserMessage(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        borderLeft: '1px solid #e8e8e8',
                        justifyContent: 'space-between',
                        marginBottom: 10,
                      }}
                    >
                      {selectedFile && (
                        <div
                          style={{
                            width: '100%',
                            background: '#00000000',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            paddingLeft: 10,
                          }}
                        >
                          <div
                            style={{
                              textDecoration: 'none',
                              color: '#808080',
                              display: 'flex',
                              justifyContent: 'flex-start',
                              alignItems: 'center',
                              width: '90%',
                            }}
                            target="_blank"
                          >
                            <div style={{ width: 25 }}>
                              <FileTypeIcons
                                type={selectedFile.type}
                                style={{ width: 15, height: 15 }}
                              />
                            </div>
                            <Typography
                              noWrap
                              style={{ textOverflow: 'ellipsis', width: '80%' }}
                            >
                              {selectedFile.name}
                            </Typography>
                          </div>
                          <IconButton
                            onClick={() => setSelectedFile(undefined)}
                          >
                            <RemoveCircle
                              style={{ color: '#b70000', fontSize: 17.5 }}
                            />
                          </IconButton>
                        </div>
                      )}
                      <input
                        id="myInput"
                        type="file"
                        ref={filePicker}
                        style={{ display: 'none' }}
                        onChange={selectFile}
                        onClick={(event) => (event.target.value = '')}
                      />
                      {selectedFile ? (
                        <IconButton onClick={sendFile}>
                          {sendingMessage ? (
                            <CircularProgress
                              classes={{
                                colorPrimary: classes.colorPrimary,
                              }}
                              size={25}
                            />
                          ) : (
                            <DynamicIcon
                              iconId={908}
                              style={{
                                width: 20,
                                height: 20,
                                cursor: 'pointer',
                              }}
                            />
                          )}
                        </IconButton>
                      ) : (
                        <IconButton onClick={() => filePicker.current.click()}>
                          <DynamicIcon
                            iconId={7}
                            style={{
                              width: 17.5,
                              height: 17.5,
                              cursor: 'pointer',
                            }}
                          />
                        </IconButton>
                      )}
                    </div>
                  </InputAdornment>
                ),
              }}
            />
            <Typography
              style={{ color: '#525252', fontSize: 10, marginTop: 5 }}
            >
              *Press enter to send message
            </Typography>
          </div>
        </div>
      </div>
      {currentDeepLink && (
        <DynamicView
          deeplink={currentDeepLink}
          hideToolbar
          {...props}
          overrideHandleDeepLink={true}
          rightSideBar={rightSideBar}
          setBotMessage={setBotMessage}
          setMessage={setMessage}
        />
      )}
    </>
  );
}

const MessageReceived = ({ comment, ...props }) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'flex-end',
        marginTop: 10,
        marginBottom: 10,
      }}
    >
      {!props.isLogoNotRequired && (
        <Card
          style={{
            height: 50,
            width: 50,
            borderRadius: 25,
            overflow: 'hidden',
            boxShadow: '20px 20px 100px #00000011',
            margin: 0,
            marginLeft: 20,
          }}
        >
          <img
            src={
              comment.avatar || comment.avatar_url || comment.user_avatar_url
            }
            style={{ height: 50, width: 50, borderRadius: 25 }}
          />
        </Card>
      )}
      <div style={{ maxWidth: '70%', marginLeft: 20 }}>
        {!isEmpty(comment.payload) ? (
          <PayloadRenderer
            payload={comment.payload}
            comment={comment}
            {...props}
          />
        ) : (
          <Card
            style={{
              borderRadius: 15,
              borderBottomLeftRadius: 2,
              background: '#dce7ff',
              boxShadow: '20px 20px 100px #00000011',
              color: '#272b2f',
              padding: 10,
              fontSize: 17.5,
              maxWidth: '100%',
              display: 'flex',
              alignItems: 'flex-end',
              flexShrink: 1,
              flexWrap: 'wrap',
            }}
          >
            <Linkify
              style={{
                flexWrap: 'wrap',
                wordWrap: 'break-word',
                maxWidth: '90%',
              }}
            >
              {textFormatter(comment.message || '')}
            </Linkify>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-end',
                alignItems: 'center',
                flexGrow: 1,
              }}
            >
              <div
                style={{
                  textAlign: 'right',
                  color: '#787878',
                  fontSize: 12,
                  margin: '5px 5px 0px 15px',
                }}
              >
                {moment.unix(comment.unix_timestamp).format('hh:mm a')}
              </div>
            </div>
          </Card>
        )}
      </div>
    </div>
  );
};

const MessageSent = ({ comment, ...props }) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'flex-end',
        marginTop: 10,
        marginBottom: 10,
      }}
    >
      {!isEmpty(comment.payload) ? (
        <PayloadRenderer
          payload={comment.payload}
          comment={comment}
          {...props}
        />
      ) : (
        <Card
          style={{
            borderRadius: 15,
            borderBottomRightRadius: 2,
            background: '#3d65fe',
            boxShadow: '20px 20px 100px #00000011',
            color: '#ffffff',
            padding: 10,
            fontSize: 17.5,
            maxWidth: '80%',
            marginRight: 20,
            display: 'flex',
            alignItems: 'flex-end',
            flexShrink: 1,
            flexWrap: 'wrap',
          }}
        >
          <Linkify
            style={{
              flexWrap: 'wrap',
              wordWrap: 'break-word',
              maxWidth: '90%',
            }}
          >
            {textFormatter(comment.message || '')}
          </Linkify>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end',
              alignItems: 'center',
              flexGrow: 1,
            }}
          >
            <div
              style={{
                textAlign: 'right',
                color: '#e8e8e8',
                fontSize: 12,
                margin: '5px 5px 0px 15px',
              }}
            >
              {moment.unix(comment.unix_timestamp).format('hh:mm a')}
            </div>
          </div>
        </Card>
      )}
    </div>
  );
};

export const ChatBubble = ({ comment, transaction, ...props }) => {
  const messageBubbles = {
    sent: MessageSent,
    received: MessageReceived,
  };
  const CurrentMessageBubble = messageBubbles[transaction];

  return <CurrentMessageBubble {...{ ...props, comment, transaction }} />;
};

const DynamicChatRoom = ({
  chatRoom,
  setMessage,
  handleDeeplink,
  insideDialog,
  ...props
}) => {
  const classes = useStyles();
  const user = useAuthUserContext();
  const [chatRoomData, setChatRoomData] = React.useState({});
  const [comments, setComments] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [formData, setFormData] = React.useState({});
  const formHandlers = FormControl(formData, setFormData);
  const [sendingMessage, setSendingMessage] = React.useState(false);
  const [chatMessage, setChatMessage] = React.useState('');
  const [selectedFile, setSelectedFile] = React.useState(undefined);
  const [noMoreComments, setNoMoreComments] = React.useState(false);
  const messageList = React.useRef({});
  const filePicker = React.useRef({});
  const inputBlock = React.useRef({});

  const fetchMessages = React.useCallback((completionCallback) => {
    fetchChatRoom(chatRoom.room_id)
      .then((chatRoomData) => {
        setChatRoomData(chatRoomData);
        setComments(chatRoomData.comments || []);
        (completionCallback || (() => {}))();
      })
      .catch((error) => {
        setMessage(
          error.errorMessage || error.userMessage || 'Something went wrong'
        );
      });
  });

  const loadMoreComments = () => {
    fetchMoreFromChatRoom(chatRoom.room_id, (comments[0] || {}).id, 20).then(
      (loadedComments) => {
        setComments([...loadedComments, ...comments]);
        setNoMoreComments(!loadedComments || loadedComments.length < 20);
      }
    );
  };

  const newMessageHandler = (newMessage) => {
    if ((newMessage || {}).isLast && (newMessage || {}).email !== user.userId) {
      fetchMessages();
    }
  };

  React.useEffect(() => {
    setLoading(true);
    fetchMessages(() => {
      messageList.current.scrollTop = messageList.current.scrollHeight;
      setLoading(false);
    });
  }, [chatRoom.room_id]);

  React.useEffect(() => {
    emitter.on('new-message', newMessageHandler);
    return () => {
      emitter.off('new-message', newMessageHandler);
    };
  }, [chatRoom.room_id]);

  const sendMessageToRoom = (text, type, payload) => {
    const msg = chatMessage && chatMessage.trim();
    if (msg || text) {
      setSendingMessage(true);
      sendMessage(chatRoom.room_id, text || msg, type, payload).then(
        (response) => {
          setChatMessage('');
          setSelectedFile(undefined);
          setSendingMessage(false);
        }
      );
    }
  };

  const sendFile = () => {
    uploadFile(
      selectedFile,
      () => setSendingMessage(true),
      (data, file) => {
        const payload = {
          url: data.fileUrl,
          caption: chatMessage && chatMessage.trim(),
          file_name: file.name,
          file_type: file.type,
        };
        sendMessageToRoom(
          `[file] ${data.fileUrl} [/file]`,
          'file_attachment',
          payload
        );
      },
      (error = {}) => {
        setSendingMessage(false);
        setMessage(error.userMessage || error.errorMessage);
      }
    );
  };

  const onKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      sendMessageToRoom();
      return;
    }
  };

  const selectFile = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  return (
    <div
      style={{
        ...(insideDialog
          ? { width: '548px', maxWidth: '548px', height: '75vh' }
          : { width: '50vw', height: '85vh' }),
        overflow: 'hidden',
        background: '#f8fbff',
      }}
    >
      <div
        style={{
          height: `calc(100% - ${get(inputBlock, [
            'current',
            'clientHeight',
          ])}px)`,
          position: 'relative',
          // overflow:'scroll'
        }}
      >
        <div
          style={{
            height: '100%',
            maxHeight: '100%',
            display: 'flex',
            flexDirection: 'column',
            // justifyContent:'flex-end',
            overflow: 'auto',
          }}
          ref={messageList}
        >
          <div
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {!noMoreComments && (
              <button
                onClick={loadMoreComments}
                style={{
                  padding: '0px 8px 0px 8px',
                  border: 'none',
                  outline: 'none',
                  cursor: 'pointer',
                  borderRadius: 15,
                  background: `#dce7ff`,
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: 150,
                  margin: '5px 5px 0px 5px',
                }}
              >
                <Typography
                  style={{
                    textAlign: 'center',
                    color: '#272b2f',
                  }}
                >
                  Load More
                </Typography>
              </button>
            )}
          </div>
          {(comments || []).map((comment) => (
            <ChatBubble
              comment={comment}
              transaction={
                (comment.username_real || comment.email) !== user.userId
                  ? 'received'
                  : 'sent'
              }
              {...{ formData, formHandlers, handleDeeplink }}
            />
          ))}
        </div>
        {loading && (
          <LoadingSheet
            containerStyle={{
              position: 'absolute',
              top: 0,
              ...(insideDialog
                ? { width: '548px', maxWidth: '548px', height: '75vh' }
                : { width: '50vw', height: '85vh' }),
            }}
          />
        )}
      </div>
      <div
        ref={inputBlock}
        style={{ position: 'absolute', bottom: 0, width: '100%' }}
      >
        {selectedFile && (
          <div
            style={{
              height: 45,
              width: '100%',
              bottom: 0,
              background: '#f8fbff',
              boxShadow: '20px 20px 100px #00000044',
              borderBottom: '1.5px solid #e8e8e8',
              padding: '7.5px 10px 7.5px 10px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <div
              style={{
                textDecoration: 'none',
                color: '#808080',
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'baseline',
                width: '90%',
              }}
              target="_blank"
            >
              <div style={{ width: 25 }}>
                <FileTypeIcons
                  type={selectedFile.type}
                  style={{ width: 15, height: 15 }}
                />
              </div>
              <Typography
                noWrap
                style={{ textOverflow: 'ellipsis', width: '80%' }}
              >
                {selectedFile.name}
              </Typography>
            </div>
            <IconButton onClick={() => setSelectedFile(undefined)}>
              <RemoveCircle style={{ color: '#b70000', fontSize: 17.5 }} />
            </IconButton>
          </div>
        )}
        <div
          style={{
            width: '100%',
            padding: '10px 10px 10px 10px',
            borderBottomLeftRadius: 12,
            borderBottomRightRadius: 12,
            border: '1px solid #e8e8e8',
            background: '#ffffff',
          }}
        >
          <Card
            style={{
              background: '#ffffff',
              borderRadius: 25,
              padding: '5px 5px 5px 5px',
              boxShadow: 'none',
            }}
          >
            <TextField
              id="standard-basic"
              placeholder="Type a message here"
              style={{ alignSelf: 'flex-end', width: '100%' }}
              onKeyPress={onKeyPress}
              value={chatMessage}
              multiline={true}
              rowsMax={4}
              disableUnderline
              onChange={(e) => setChatMessage(e.target.value)}
              InputProps={{
                style: {
                  display: 'flex',
                  alignItems: 'flex-end',
                  width: '100%',
                },
                disableUnderline: true,
                startAdornment: (
                  <InputAdornment>
                    <>
                      <input
                        id="myInput"
                        type="file"
                        ref={filePicker}
                        style={{ display: 'none' }}
                        onChange={selectFile}
                      />
                      <IconButton
                        onClick={() => filePicker.current.click()}
                        style={{ marginBottom: 17.5 }}
                      >
                        <DynamicIcon
                          iconId={7}
                          style={{
                            width: '25',
                            height: '25',
                            cursor: 'pointer',
                          }}
                        />
                      </IconButton>
                    </>
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment>
                    <IconButton
                      onClick={selectedFile ? sendFile : sendMessageToRoom}
                      style={{ padding: 2, marginBottom: 17.5 }}
                    >
                      {sendingMessage ? (
                        <CircularProgress
                          classes={{
                            colorPrimary: classes.colorPrimary,
                          }}
                          size={25}
                        />
                      ) : (
                        <DynamicIcon
                          iconId={908}
                          style={{
                            width: '40px',
                            height: '40px',
                            cursor: 'pointer',
                          }}
                        />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Card>
        </div>
      </div>
    </div>
  );
};

function DynamicCardTabView({
  tabs,
  curTabIndex,
  bodyKey,
  rightSideBar,
  setMessage,
  ...props
}) {
  const classes = useStyles();

  const [selectedTabIndex, setSelectedTabIndex] = React.useState(
    curTabIndex || 0
  );
  const [cardTabs, setCardTabs] = React.useState(tabs);
  const [parentRefresh, setParentRefresh] = React.useState('');

  const fetchCards = (deeplink) => {
    props.handleDeeplink(deeplink).then((response) => {
      if (response) {
        response.tabCards && setCardTabs(response.tabCards);
        response.curTabIndex !== undefined &&
          setSelectedTabIndex(response.curTabIndex || 0);
      }
      setParentRefresh(Date.now());
    });
  };

  const recordChildState = (childState) => {
    if (props.tabFormKey) {
      (props.setFormState || (() => {}))({
        [props.tabFormKey]: {
          ...props.formData[props.tabFormKey],
          [(cardTabs[selectedTabIndex] || {}).title]: childState,
        },
      });
    }
  };

  React.useEffect(() => {
    (props.setFormState || (() => {}))({
      [props.tabFormKey]: {
        ...((cardTabs || []).reduce(
          (state, currentTab) => ({ ...state, [currentTab.title]: {} }),
          {}
        ) || {}),
      },
    });
  }, [cardTabs]);

  const activeTab = cardTabs && cardTabs[selectedTabIndex];

  React.useEffect(() => {
    setCardTabs(tabs);
    setSelectedTabIndex(curTabIndex || 0);
  }, [curTabIndex, tabs]);

  return (
    <>
      <div className={classes.cardTabsContainer}>
        {cardTabs &&
          cardTabs.map((tabCard, index) => (
            <div
              style={{
                marginRight: 37.5,
                cursor: 'pointer',
              }}
              onClick={() => {
                tabCard.refreshDeeplink
                  ? fetchCards(tabCard.refreshDeeplink)
                  : setSelectedTabIndex(index);
              }}
            >
              <CardCompopnent
                key={`card-${tabCard.card.id || index}`}
                {...props}
                {...tabCard.card}
                current={index}
                selected={selectedTabIndex}
              />
            </div>
          ))}
      </div>
      {activeTab && (
        <DynamicView
          deeplink={activeTab.deep_link}
          json={activeTab.tabContent}
          hideToolbar
          {...props}
          fetchCards={fetchCards}
          currentTabIndex={selectedTabIndex}
          recordChildState={recordChildState}
          stateParentCopy={
            (props.formData[props.tabFormKey] || {})[
              (cardTabs[selectedTabIndex] || {}).title
            ]
          }
          rightSideBar={rightSideBar}
          parentRefresh={parentRefresh}
          setMessage={setMessage}
        />
      )}
    </>
  );
}

function DynamicTabBoxesView({
  tabBoxes,
  curTabIndex,
  rightSideBar,
  setMessage,
  ...props
}) {
  const [selectedTabIndex, setSelectedTabIndex] = React.useState(
    curTabIndex || 0
  );
  const classes = useStyles();
  const location = useLocation();

  const recordChildState = (childState) => {
    if (props.tabFormKey) {
      (props.setFormState || (() => {}))({
        [props.tabFormKey]: {
          ...props.formData[props.tabFormKey],
          [(tabBoxes[selectedTabIndex] || {}).title]: childState,
        },
      });
    }
  };

  React.useEffect(() => {
    (props.setFormState || (() => {}))({
      [props.tabFormKey]: {
        ...((tabBoxes || []).reduce(
          (state, currentTab) => ({ ...state, [currentTab.title]: {} }),
          {}
        ) || {}),
      },
    });
  }, [tabBoxes]);

  let refreshCapturer = () => {};

  React.useEffect(() => {
    setSelectedTabIndex(curTabIndex || 0);
  }, [curTabIndex, tabBoxes, location]);

  const activeTab = tabBoxes && tabBoxes[selectedTabIndex];

  return (
    <>
      <Box display="flex">
        {tabBoxes &&
          tabBoxes.map((tab, index) => (
            <Box
              key={index}
              px={3}
              py={1}
              display="flex"
              alignItems="center"
              style={{
                backgroundColor: '#ffffff',
                color: selectedTabIndex === index ? '#505050' : '#898989',
                border:
                  selectedTabIndex === index ? '1px solid #E2E2E2' : 'unset',
                borderBottom:
                  selectedTabIndex === index ? 0 : '1px solid #E2E2E2',
                cursor: 'pointer',
              }}
              onClick={(e) => setSelectedTabIndex(index)}
            >
              <Typography>{(tab.title || '').toUpperCase()}</Typography>
              {tab.refreshAction && (
                <Tooltip
                  title={tab.refreshAction.title || 'Refresh'}
                  placement="top"
                >
                  <IconButton
                    className={classes.iconRippleLess}
                    style={{ marginRight: -20 }}
                    onClick={() =>
                      refreshCapturer(tab.refreshAction.refreshDeeplink || '')
                    }
                  >
                    <DynamicIcon
                      iconId={tab.refreshAction.iconId}
                      style={{
                        width: '40px',
                        height: '20px',
                      }}
                    />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
          ))}
        <Box flex={1} style={{ borderBottom: '1px solid #e2e2e2' }}></Box>
      </Box>
      {activeTab && (
        <DynamicView
          refreshHandler={(refreshHandler) => {
            refreshCapturer = refreshHandler;
          }}
          deeplink={activeTab.deep_link}
          hideToolbar
          rightSideBar={rightSideBar}
          currentTabIndex={selectedTabIndex}
          recordChildState={recordChildState}
          stateParentCopy={
            (props.formData[props.tabFormKey] || {})[
              (tabBoxes[selectedTabIndex] || {}).title
            ]
          }
          setMessage={setMessage}
          {...props}
          border={true}
        />
      )}
    </>
  );
}

function DynamicHeaderTabsView({
  tabs,
  curTabIndex,
  setHeaderTabs,
  headerTabs,
  rightSideBar,
  setMessage,
  hasMountedHeaderTabs,
  setHasMountedHeaderTabs,
  ...props
}) {
  const [selectedTabIndex, setSelectedTabIndex] = React.useState(
    curTabIndex || 0
  );
  const classes = useStyles();
  const history = useHistory();

  const recordChildState = (childState) => {
    if (props.tabFormKey) {
      (props.setFormState || (() => {}))({
        [props.tabFormKey]: {
          ...props.formData[props.tabFormKey],
          [(tabs[selectedTabIndex] || {}).title]: childState,
        },
      });
    }
  };

  React.useEffect(() => {
    (props.setFormState || (() => {}))({
      [props.tabFormKey]: {
        ...((tabs || []).reduce(
          (state, currentTab) => ({ ...state, [currentTab.title]: {} }),
          {}
        ) || {}),
      },
    });
  }, [tabs]);

  React.useEffect(() => {
    (setHeaderTabs || (() => {}))(
      tabs && (
        <Tabs
          variant="scrollable"
          value={selectedTabIndex}
          classes={{
            indicator: classes.tabsIndicator,
            flexContainer: classes.tabsContainer,
          }}
          onChange={(e, tabIndex) => {
            setSelectedTabIndex(tabIndex);
          }}
          scrollButtons="auto"
        >
          {tabs.map((tab, index) => (
            <Tab
              label={(tab.title || '').toUpperCase()}
              key={index}
              classes={{ root: classes.tab, selected: classes.selectedTab }}
              wrapped
            />
          ))}
        </Tabs>
      )
    );
    (setHasMountedHeaderTabs || (() => {}))(true);
  }, [
    classes.selectedTab,
    classes.tab,
    classes.tabsContainer,
    classes.tabsIndicator,
    selectedTabIndex,
    setHeaderTabs,
    tabs,
  ]);

  const activeTab = tabs && tabs[selectedTabIndex];

  // !headerTabs&&(setHeaderTabs||(()=>{}))(tabs &&
  //   <Tabs value={selectedTabIndex} indicatorColor= "primary" onChange={(e, tabIndex) => setSelectedTabIndex(tabIndex)}>
  //     {tabs.map((tab, index) => (
  //       <Tab label={tab.title} key={index} />
  //     ))}
  //   </Tabs>)

  return (
    activeTab && (
      <DynamicView
        headerTabContent={true}
        deeplink={activeTab.deep_link}
        json={activeTab.tabContent}
        hideToolbar
        rightSideBar={rightSideBar}
        currentTabIndex={selectedTabIndex}
        recordChildState={recordChildState}
        stateParentCopy={
          (props.formData[props.tabFormKey] || {})[
            (tabs[selectedTabIndex] || {}).title
          ]
        }
        setDeepLink={undefined}
        setMessage={setMessage}
        {...props}
      />
    )
  );
}

function DynamicTitlebar({ title, iconActions }) {
  const classes = useStyles();
  return (
    <AppBar position="relative" elevation={0} className={classes.titlebar}>
      <Toolbar>
        <Box flexGrow={1}>
          <Typography variant="h6" noWrap={true} spacing={1}>
            {title}
          </Typography>
        </Box>
        {iconActions}
      </Toolbar>
    </AppBar>
  );
}

const DynamicButtons = (props) => {
  const {
    buttons,
    formData,
    handleDeeplink,
    dialogActionFunctionality,
    resetFormState,
    setDeepLink,
  } = props;

  const [clickedButton, setClickedButton] = React.useState(-1);
  const [buttonDisabled, setButtonDisabled] = React.useState(false);

  const handleClick = (button, index) => {
    if (button.apiType === 1) {
      dialogActionFunctionality({ refreshDeeplink: button.deep_link });
    } else {
      setClickedButton(index);
      setButtonDisabled(true);
      sendAmplitudeData('Dynamic Button Clicked', {
        deep_link: button.deep_link,
        formBody: { ...formData },
        apiType: button.apiType,
      });
      button.deep_link &&
        handleDeeplink(
          button.deep_link,
          button.apiType,
          formData,
          button.localStoreKeys ? {} : { doneCallback: setDeepLink },
          button.localStoreKeys && {
            localKeys: button.localStoreKeys,
            ...(props.miscItems || {}),
          }
        ).then((response) => {
          if (response) {
            if (/refreshPopup/.test(response.refreshDeeplink)) {
              props.setDialogDeeplink(
                response.refreshDeeplink.replace('/refreshPopup', '')
              );
              SMConfirmDialogControl.close();
            } else {
              /^(http|https):\/\/(.+)/.test(
                response.refreshDeeplink ||
                  (response.data || {}).refreshDeeplink ||
                  ''
              )
                ? handleDeeplink(
                    response.refreshDeeplink ||
                      (response.data || {}).refreshDeeplink
                  )
                : dialogActionFunctionality(response || {});
            }
            (resetFormState || (() => {}))();
            (response.redirectLink ||
              (response.data && response.data.redirectLink)) &&
              /^(http|https):\/\/(.+)/.test(
                response.redirectLink ||
                  (response.data || {}).redirectLink ||
                  ''
              ) &&
              handleDeeplink(
                response.redirectLink || (response.data || {}).redirectLink
              );
          }
          setClickedButton(-1);
          setButtonDisabled(false);
          sendAmplitudeData('Dynamic Button response', {
            deep_link: button.deep_link,
            response: { ...response },
          });

          // (resetFormState || (() => {}))();
          // ToDo done this during magic form changes for vaccination flow
        });
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row-reverse',
        // minWidth:500
      }}
    >
      {buttons.map((button, index) => (
        <Button
          disabled={buttonDisabled || props.responseAwaited}
          style={{
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
            margin: 10,
            background: '#233C97',
            color: '#ffffff',
            padding: '5px 15px 5px 15px',
            fontWeight: 'bold',
            fontSize: 18,
          }}
          onClick={() => handleClick(button, index)}
        >
          {(clickedButton === index && (
            <CircularProgress
              thickness={5}
              size={28}
              style={{ color: '#ffffff' }}
            />
          )) ||
            button.title}
        </Button>
      ))}
    </div>
  );
};

const DynamicImportButtons = (props) => {
  const {
    imports,
    formData,
    handleDeeplink,
    dialogActionFunctionality,
    setDeepLink,
    resetFormState,
    setMessage,
  } = props;
  const fileInputRef = React.useRef({});

  const handleClick = (button) => {
    if (button.apiType === 1) {
      dialogActionFunctionality({ refreshDeeplink: button.deep_link });
    } else {
      handleDeeplink(
        `${button.deep_link}/multiple-import`,
        button.apiType,
        formData,
        {},
        {
          fileInputRef,
          columns: button.importSchema,
          importKey: button.importKey,
          bodyKey: button.bodyKey,
          titleKey: button.titleKey,
          captureTitle: button.captureTitle,
          refresh: setDeepLink,
          setMessage: setMessage,
        }
      ).then((response) => {
        dialogActionFunctionality(response || {});
        (resetFormState || (() => {}))();
      });
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row-reverse',
        // minWidth:500
      }}
    >
      <input
        type="file"
        accept=".xlsx, .csv, .xls"
        style={{ display: 'none' }}
        ref={fileInputRef}
      />
      {imports.map((button) => (
        <Button
          style={{
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
            margin: 10,
            background:
              'transparent linear-gradient(240deg, #7467F0 0%, #2896E9 100%) 0% 0% no-repeat padding-box',
            color: '#ffffff',
            padding: '5px 15px 5px 15px',
            fontWeight: 'bold',
          }}
          onClick={() => handleClick(button)}
        >
          {button.title}
        </Button>
      ))}
    </div>
  );
};

function useDynamicJSON({
  url,
  query,
  refreshAt,
  deeplink,
  json,
  navigate,
  setHeaderTabs,
  headerTabs,
  scrollable = true,
  handleDeeplink,
  setMessage,
  fetchCards,
  setDeepLink,
  overrideHandleDeepLink,
  dialogActionFunctionality,
  setSidebarData,
  sidebarData,
  setPrevDeepLink,
  rightSideBar,
  setBotMessage,
  navigationStack,
  setNavigationStack,
  setLoading,
  open,
  insideDialog,
  refreshHandler,
  dialogUtils,
  showMap,
  setJourney,
  setMapCenter,
  setMapBounds,
  parentRefresh,
  setCurrentScreenRevisitable,
  setNonRevisitableStack,
  setScreenStackLength,
  screenStackLength,
  nonRevisitableStack,
  miscItems,
  miscHandlers,
  miscAttributes,
  recordChildState,
  hasMountedHeaderTabs,
  setHasMountedHeaderTabs,
  rootLevel,
  localCurrentTab,
  setLocalCurrentTab,
  currentTabIndex,
  localSetDeeplink,
  setErrorBlock,
  setDialogDeeplink,
  ...props
}) {
  const [data, setData] = React.useState({});
  const [formData, setFormData] = React.useState({});
  const [responseAwaited, setResponseAwaited] = React.useState(false);
  const formHandlers = FormControl(formData, setFormData);
  const { target } = useParams();
  const handleDeeplinkFunction = (
    deeplink,
    apiType,
    reqData = undefined,
    localMiscHandlers,
    localMiscItems
  ) => {
    return processDeeplink(
      deeplink,
      apiType,
      reqData || formData,
      localMiscHandlers || miscHandlers || {},
      localMiscItems || miscItems || {}
    )
      .then((response) => {
        if (response) {
          if (response.data) {
            response.data.userToken &&
              persistentStore.set('user-token', {
                'user-token': response.data.userToken,
              });
            (response.data.clearKeyList || []).forEach((key) =>
              persistentStore.remove(key)
            );
            response.data.userMessage && setMessage(response.data.userMessage);
            return response.data;
          }
          if (response.error) throw response.error;
        }
      })
      .catch((err) => {
        console.log(err);
        sendAmplitudeData('handleDeepLinkFunctionError', {
          failure: err,
          deeplink: deeplink,
          apiType: apiType,
          requestData: reqData,
        });
        setErrorBlock(err);
        return undefined;
      });
  };

  React.useEffect(() => {
    (recordChildState || props.setFormData || (() => {}))(formData);
  }, [formData]);

  const handlers = {
    handleDeeplink: handleDeeplink || handleDeeplinkFunction,
    formData,
    fetchCards,
    setMessage,
    ...formHandlers,
  };

  React.useEffect(() => {
    setLoading(false);
  }, [data]);

  React.useEffect(() => {
    setFormData({ ...formData, ...(props.formBody || {}) });
  }, [props.formBody]);

  React.useEffect(() => {
    if (!open) {
      formHandlers.resetFormState();
    }
  }, [open]);

  React.useEffect(() => {
    (setDeepLink || (() => {}))('');
    if (url) {
      (setLoading || (() => {}))(true);
      fetchDynamicJSON(url, query).then((response) => {
        response &&
          response.data &&
          response.data.userToken &&
          persistentStore.set('user-token', {
            'user-token': response.data.userToken,
          });
        try {
          setCurrentScreenRevisitable((response.data || {}).revisitable);
          if ((response.data || {}).revisitable) {
            setNavigationStack([(url || '').replace(config.baseURL, '')]);
          }
          if (
            (url || '').replace(config.baseURL, '') !==
            navigationStack[navigationStack.length - 1]
          ) {
            setScreenStackLength(1);
          }
          if (!(response.data || {}).revisitable) {
            setNonRevisitableStack(1);
          }
          (setHeaderTabs || (() => {}))([]);
          response.data && setData(response.data);
          (setSidebarData || (() => {}))(undefined);
          if (response.error) throw response.error;
        } catch (err) {
          console.log(err);
          setErrorBlock(err);
        }
      });
    }
  }, [url]);
  const history = useHistory();

  React.useEffect(() => {
    (refreshHandler || (() => {}))(loadContent);
    if (json) {
      setData(json);
      return;
    }
    if (deeplink) {
      loadContent(deeplink);
    }
  }, [query, refreshAt, deeplink, json, setSidebarData, setMessage]);

  const loadContent = (deeplink) => {
    (setDeepLink || (() => {}))('');
    (setLoading || (() => {}))(true);
    /(pushUrl)/.test(deeplink || '')
      ? history.push(
          deeplinkToURL(deeplink, `/${target || ''}`).replace('/pushUrl', ''),
          {
            refreshAt: +Date.now(),
          }
        )
      : fetchDynamicJSON(deeplinkToURL(deeplink)) // may contain query in URL
          .then((response) => {
            try {
              (setCurrentScreenRevisitable || (() => {}))(
                (response.data || {}).revisitable
              );
              if (
                !!deeplink &&
                deeplink !== '' &&
                (response.data || {}).revisitable &&
                (deeplink || '').replace('spacemonk://') !==
                  (
                    (navigationStack || [])[
                      (navigationStack || []).length - 1
                    ] || ''
                  ).replace('spacemonk://')
              ) {
                setNavigationStack([...(navigationStack || []), deeplink]);
              }
              if (
                deeplink !== '' &&
                (deeplink || '').replace('spacemonk://') !==
                  (
                    (navigationStack || [])[
                      (navigationStack || []).length - 1
                    ] || ''
                  ).replace('spacemonk://')
              ) {
                (setScreenStackLength || (() => {}))(
                  (screenStackLength || 0) + 1
                );
              }
              if (!(response.data || {}).revisitable) {
                (setNonRevisitableStack || (() => {}))(
                  (nonRevisitableStack || 0) + 1
                );
                if (
                  !!deeplink &&
                  deeplink !== '' &&
                  (response.data || {}).revisitable &&
                  (deeplink || '').replace('spacemonk://') !==
                    (
                      (navigationStack || [])[
                        (navigationStack || []).length - 1
                      ] || ''
                    ).replace('spacemonk://')
                ) {
                  setNavigationStack([...(navigationStack || []), deeplink]);
                }
                if (
                  deeplink !== '' &&
                  (deeplink || '').replace('spacemonk://') !==
                    (
                      (navigationStack || [])[
                        (navigationStack || []).length - 1
                      ] || ''
                    ).replace('spacemonk://')
                ) {
                  (setScreenStackLength || (() => {}))(
                    (screenStackLength || 0) + 1
                  );
                }
                if (!(response.data || {}).revisitable) {
                  (setNonRevisitableStack || (() => {}))(
                    (nonRevisitableStack || 0) + 1
                  );
                }
              } else {
                setLocalCurrentTab(currentTabIndex);
              }
              response.data && setData(response.data);
              (setSidebarData || (() => {}))(undefined);
              if (response.error) throw response.error;
            } catch (err) {
              console.log(err);
              setErrorBlock(err);
            }
          })
          .catch(console.log);

    return;
  };

  React.useEffect(() => {
    setBotMessage && setBotMessage(data.botMessage);
  }, [data.botMessage, setBotMessage]);

  React.useEffect(() => {
    (setJourney || (() => {}))({
      pickup: data.pickup,
      destination: data.destination,
    });
    if (data.pickup && data.destination) {
      (setMapCenter || (() => {}))(getMapCenter(data.pickup, data.destination));
      (setMapBounds || (() => {}))([data.pickup, data.destination]);
    }
  }, [data.pickup, data.destination, showMap]);

  React.useEffect(() => {
    (setPrevDeepLink || (() => {}))((data || {}).back_deep_link);
  }, [data, data.back_deep_link, setPrevDeepLink]);

  React.useEffect(() => {
    if (!data.headerTabs && hasMountedHeaderTabs) {
      setHasMountedHeaderTabs(false);
      setHeaderTabs([]);
    }
  }, [data.headerTabs]);

  const handleDeeplinkHTTPSWrapper = (deeplink) => {
    const regexHandler = [
      {
        pattern: /^(http|https):\/\/(.+)/,
        operation: (deeplink) => window.open(deeplink, '_blank'),
      },
      {
        pattern: /(print)/,
        operation: (deeplink) => clickToPrint(deeplink.replace('/print', '')),
      },
      {
        pattern: /(dialog|view|confirm|prompt)/,
        operation: (deeplink) =>
          handleDeeplinkFunction(
            deeplink,
            1,
            {},
            { doneCallback: (refreshDeeplink) => setDeepLink(refreshDeeplink) }
          ),
      },
    ];
    const currentRoute = regexHandler.find((route) =>
      route.pattern.test(deeplink)
    );

    !!currentRoute ? currentRoute.operation(deeplink) : setDeepLink(deeplink);
  };

  return {
    title: data.title,
    iconActions: data.icons && (
      <DynamicIconActions
        {...handlers}
        icons={data.icons}
        setMessage={setMessage}
        {...{ dialogActionFunctionality }}
      />
    ),
    importButtons: data.imports && (
      <DynamicImportButtons
        {...handlers}
        {...{ dialogActionFunctionality }}
        imports={data.imports}
        setMessage={setMessage}
        setDeepLink={setDeepLink}
      />
    ),
    buttons: data.buttons && (
      <DynamicButtons
        {...handlers}
        {...{ dialogActionFunctionality }}
        buttons={data.buttons}
        setMessage={setMessage}
        responseAwaited={responseAwaited}
        setDeepLink={handleDeeplinkHTTPSWrapper}
        setDialogDeeplink={setDialogDeeplink}
      />
    ),
    sections: data.sections && (
      <DynamicSectionsView
        {...handlers}
        isLarge={props.isLarge}
        dialogUtils={dialogUtils}
        recordChildState={recordChildState}
        scrollable={scrollable}
        localSetDeeplink={localSetDeeplink}
        sections={data.sections}
        onDone={dialogActionFunctionality}
        miscItems={miscItems}
        miscHandlers={miscHandlers}
        stateParentCopy={props.stateParentCopy}
        miscAttributes={miscAttributes}
        nextPageUrl={data.nextPageUrl}
        setDeepLink={handleDeeplinkHTTPSWrapper}
        setSidebarData={setSidebarData}
        sidebarData={sidebarData}
        overrideHandleDeepLink={overrideHandleDeepLink}
        rightSideBar={rightSideBar}
        setMessage={setMessage}
        insideDialog={insideDialog}
        responseAwaited={responseAwaited}
        setResponseAwaited={setResponseAwaited}
        setDialogDeeplink={setDialogDeeplink}
      />
    ),
    tabs: data.tabs && (
      <DynamicTabsView
        {...handlers}
        {...{ dialogActionFunctionality }}
        localSetDeeplink={localSetDeeplink}
        tabs={data.tabs}
        curTabIndex={data.curTabIndex}
        newTabDeeplink={data.newTabDeeplink}
        tabFormKey={data.tabFormKey}
        onDone={dialogActionFunctionality}
        refreshAt={refreshAt}
        navigate={navigate}
        rightSideBar={rightSideBar}
        setSidebarData={setSidebarData}
        setDeepLink={handleDeeplinkHTTPSWrapper}
        setMessage={setMessage}
        overrideHandleDeepLink={overrideHandleDeepLink}
      />
    ),
    tabCards: data.tabCards && (
      <DynamicCardTabView
        {...handlers}
        tabs={data.tabCards}
        curTabIndex={data.curTabIndex}
        tabFormKey={data.tabFormKey}
        onDone={dialogActionFunctionality}
        refreshAt={refreshAt}
        navigate={navigate}
        rightSideBar={rightSideBar}
        setSidebarData={setSidebarData}
        setDeepLink={handleDeeplinkHTTPSWrapper}
        setMessage={setMessage}
        overrideHandleDeepLink={overrideHandleDeepLink}
      />
    ),
    tabBoxes: data.tabBoxes && (
      <DynamicTabBoxesView
        {...handlers}
        tabBoxes={data.tabBoxes}
        curTabIndex={data.curTabIndex}
        tabFormKey={data.tabFormKey}
        onDone={dialogActionFunctionality}
        refreshAt={refreshAt}
        navigate={navigate}
        rightSideBar={rightSideBar}
        setSidebarData={setSidebarData}
        setDeepLink={handleDeeplinkHTTPSWrapper}
        setMessage={setMessage}
        overrideHandleDeepLink={overrideHandleDeepLink}
      />
    ),
    headerTabs: data.headerTabs && (
      <DynamicHeaderTabsView
        {...handlers}
        tabs={data.headerTabs}
        curTabIndex={data.curTabIndex}
        tabFormKey={data.tabFormKey}
        onDone={dialogActionFunctionality}
        refreshAt={refreshAt}
        headerTabs={headerTabs}
        setHeaderTabs={setHeaderTabs}
        navigate={navigate}
        rightSideBar={rightSideBar}
        setSidebarData={setSidebarData}
        overrideHandleDeepLink={overrideHandleDeepLink}
        setMessage={setMessage}
        hasMountedHeaderTabs={hasMountedHeaderTabs}
        setHasMountedHeaderTabs={setHasMountedHeaderTabs}
      />
    ),
    bot: data.bot && (
      <OnboardingBotView
        {...handlers}
        bot={data.bot}
        refreshAt={refreshAt}
        onDone={dialogActionFunctionality}
        navigate={navigate}
        rightSideBar={rightSideBar}
        setSidebarData={setSidebarData}
        setMessage={setMessage}
      />
    ),
    chatRoom: data.chatRoom && (
      <DynamicChatRoom
        {...handlers}
        chatRoom={data.chatRoom}
        onDone={dialogActionFunctionality}
        refreshAt={refreshAt}
        navigate={navigate}
        rightSideBar={rightSideBar}
        setSidebarData={setSidebarData}
        setMessage={setMessage}
        insideDialog={insideDialog}
      />
    ),
    fab: data.fab && (
      <DynamicFab fabs={data.fab} {...handlers} setMessage={setMessage} />
    ),
  };
}

export function DynamicView({
  hideToolbar,
  border,
  overrideHandleDeepLink,
  rightSideBar,
  setBotMessage,
  setMessage,
  rootLevel,
  currentTabIndex,
  headerTabContent,
  setErrorBlock,
  ...props
}) {
  const [deeplink, setDeepLink] = React.useState(props.deeplink);
  const [prevDeeplink, setPrevDeepLink] = React.useState(undefined);
  const [navigationStack, setNavigationStack] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [screenStackLength, setScreenStackLength] = React.useState(0);
  const [nonRevisitableStack, setNonRevisitableStack] = React.useState(0);
  const [headerTabs, setHeaderTabs] = React.useState([]);
  const [hasMountedHeaderTabs, setHasMountedHeaderTabs] = React.useState(false);
  const [localCurrentTab, setLocalCurrentTab] = React.useState(currentTabIndex);
  const [currentScreenRevisitable, setCurrentScreenRevisitable] =
    React.useState(false);
  const dialogActionFunctionality = (response) => {
    if ((response || {}).refreshDeeplink) {
      setDeepLink((response || {}).refreshDeeplink);
    }
  };
  const resetNavigationStack = () => {
    setCurrentScreenRevisitable(false);
    setScreenStackLength(0);
    setNonRevisitableStack(0);
    setNavigationStack([]);
  };

  React.useEffect(() => {
    if (currentTabIndex !== localCurrentTab) {
      setLocalCurrentTab(currentTabIndex);
      resetNavigationStack();
    }
    setDeepLink(props.deeplink);
  }, [props.deeplink, props.parentRefresh, currentTabIndex]);

  const components = useDynamicJSON({
    ...props,
    setHeaderTabs: rootLevel ? setHeaderTabs : () => {},
    headerTabs: rootLevel ? headerTabs : [],
    deeplink,
    setDeepLink: props.setDeepLink || setDeepLink,
    setDialogDeeplink: props.setDialogDeeplink,
    setPrevDeepLink,
    overrideHandleDeepLink,
    setBotMessage,
    dialogActionFunctionality,
    rightSideBar,
    navigationStack,
    setNavigationStack,
    setMessage,
    setLoading,
    setCurrentScreenRevisitable,
    setScreenStackLength,
    setNonRevisitableStack,
    screenStackLength,
    nonRevisitableStack,
    hasMountedHeaderTabs,
    setHasMountedHeaderTabs,
    localSetDeeplink: setDeepLink,
    localCurrentTab,
    setLocalCurrentTab,
    currentTabIndex,
    setErrorBlock,
  });

  const classes = useStyles();

  return (
    <>
      {loading ? (
        <LoadingSheet />
      ) : (
        <div
          className={classes.viewContainer}
          style={{
            boxSizing: 'border-box',
            border: border && '1px solid #e2e2e2',
            borderTop: 'unset',
            flex: 1,
            position: 'relative',
            ...(rootLevel ? { backgroundColor: '#ffffff' } : {}),
            ...(props.isMagicLinkContent
              ? props.isMobile
                ? {}
                : { borderRadius: 2, boxShadow: '0 0 5px 2px rgba(0,0,0,0.2)' }
              : {}),
          }}
        >
          {components.fab}
          <Card
            style={{
              display: 'flex',
              flexDirection: 'row-reverse',
              justifyContent: 'space-between',
              backgroundColor: '#ffffff00',
              boxShadow: 'none',
              alignItems: 'center',
              ...(rootLevel
                ? {
                    position: 'sticky',
                    top: 0,
                    backgroundColor: '#ffffff',
                    borderRadius: 0,
                    boxShadow: '0px 3px 3px #0000001C',
                    zIndex: 10,
                  }
                : {}),
            }}
          >
            {components.importButtons
              ? [components.importButtons, <div />]
              : null}
            {components.iconActions ? [components.iconActions, <div />] : null}
            {(navigationStack.length > 1 ||
              (navigationStack.length === 1 &&
                deeplink !== navigationStack[0]) ||
              !!headerTabs) && <div />}
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {(navigationStack.length > 1 ||
                (navigationStack.length === 1 &&
                  deeplink !== navigationStack[0])) && (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row-reverse',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <div />
                  {(navigationStack.length > 1 ||
                    screenStackLength > 1 ||
                    (navigationStack.length === 1 &&
                      deeplink !== navigationStack[0] &&
                      deeplink !== '' &&
                      !/spacemonk:\/\//.test(navigationStack[0]))) && (
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        color: '#2896E9',
                      }}
                    >
                      <Button
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          cursor: 'pointer',
                          background: rootLevel
                            ? 'transparent linear-gradient(240deg, #7467F0 0%, #2896E9 100%) 0% 0% no-repeat padding-box'
                            : '#00000000',
                          color: '#ffffff',
                          padding: '5px 15px 5px 15px',
                          fontWeight: 'bold',
                          margin: 10,
                          ...(rootLevel
                            ? {}
                            : { margin: 0, padding: '5px 0px 5px 0px' }),
                        }}
                        onClick={() => {
                          setDeepLink(
                            navigationStack[
                              navigationStack.length -
                                (currentScreenRevisitable ? 2 : 1)
                            ]
                          );
                          setNavigationStack(
                            navigationStack.slice(0, navigationStack.length - 1)
                          );
                          setScreenStackLength(
                            screenStackLength - (nonRevisitableStack + 1 || 2)
                          );
                          setNonRevisitableStack(0);
                        }}
                      >
                        <DynamicIcon
                          iconId={901}
                          style={{ width: 10, height: 10 }}
                          insideColoredButton={rootLevel}
                        />
                        <Typography
                          style={{
                            marginLeft: 10,
                            fontWeight: 'bold',
                            color: rootLevel ? '#ffffff' : '#909090',
                          }}
                        >
                          Back
                        </Typography>
                      </Button>
                    </div>
                  )}
                </div>
              )}

              {!!headerTabs ? (
                <div style={{ paddingLeft: 20 }}>{headerTabs}</div>
              ) : null}
            </div>
          </Card>
          <div style={{ ...(rootLevel ? { height: '100%' } : {}) }}>
            {components.bot}
            {components.sections}
            {components.buttons ? [components.buttons, <div />] : null}
            {components.tabs}
            {components.tabBoxes}
            {components.headerTabs}
            {components.tabCards}
            {components.chatRoom}
          </div>
        </div>
      )}
    </>
  );
}

export function DynamicDialogView({
  onClose,
  open,
  dynamicJSONContent,
  rightSideBar,
  dialogUtils,
  ...props
}) {
  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));
  const [loading, setLoading] = React.useState(false);
  const [deeplink, setDeepLink] = React.useState(props.deeplink);
  const [journey, setJourney] = React.useState({});
  const [mapCenter, setMapCenter] = React.useState(undefined);
  const [mapBounds, setMapBounds] = React.useState([]);
  let google = React.useRef({ current: {} });
  const showMap = dialogUtils.current.showMap;
  const isLarge = dialogUtils.current.isLarge;
  const isConfirmationDialog = dialogUtils.current.isConfirmationDialog;

  const components = useDynamicJSON({
    ...props,
    open,
    deeplink,
    setDeepLink,
    setDialogDeeplink: props.setDialogDeeplink,
    json: dynamicJSONContent,
    dialogUtils,
    setLoading,
    insideDialog: true,
    showMap,
    setJourney,
    setMapBounds,
    handleDeeplink: dialogUtils.current.handleDeeplink,
    setMapCenter,
    isLarge,
    isConfirmationDialog,
    google: google.current.googleRef,
    miscHandlers: dialogUtils.current.miscHandlers,
    formBody: dialogUtils.current.formBody,
    miscItems: dialogUtils.current.miscItems,
    dialogActionFunctionality: (data) => {
      ((data || {}).refreshDeeplink ||
        ((data || {}).data || {}).refreshDeeplink) &&
        dialogUtils.current.onDone(
          (data || {}).refreshDeeplink ||
            ((data || {}).data || {}).refreshDeeplink
        );
    },
  });

  React.useEffect(() => setDeepLink(props.deeplink), [props.deeplink]);

  const dialogSize = isConfirmationDialog
    ? { width: '30vw', height: '16vh' }
    : getDialogSize(showMap || isLarge);
  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={onClose}
      aria-labelledby="form-dialog-title"
      className={classes.dialog}
      PaperProps={{
        style: {
          width: dialogSize.width,
          maxWidth: dialogSize.width,
        },
      }}
      // ToDo @Rishav showMap should also behave as dialogSize fetch
    >
      <AppBar position="relative" elevation={0} className={classes.titlebar}>
        <Toolbar
          className={classes.dialogToolBar}
          style={!components.title ? { justifyContent: 'flex-end' } : {}}
        >
          <Typography
            style={{ fontSize: '20px', color: '#505050', opacity: 1 }}
            noWrap={true}
            flex={1}
            spacing={1}
            className={classes.dialogTitle}
          >
            {!loading && components.title}
          </Typography>
          <IconButton
            edge="start"
            color="inherit"
            onClick={onClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <DialogContent
        className={!isConfirmationDialog && classes.dialogContent}
        style={{
          overflowY: 'hidden',
          maxHeight: dialogSize.height,
          paddingBottom: !isConfirmationDialog && 30,
        }}
      >
        <div
          style={{
            height: !isConfirmationDialog && dialogSize.height,
            maxHeight: dialogSize.height,
            display: 'flex',
            padding: 5,
          }}
        >
          {showMap && (
            <div style={{ flex: 2, position: 'relative' }}>
              <MapComponent
                centerAroundCurrentLocation={false}
                googleRef={(ref) => {
                  google.current.googleRef = ref;
                  google.current.mapDirector = new ref.maps.DirectionsService();
                }}
                containerStyle={{
                  height: '98%',
                  width: '98%',
                  backgroundColor: '#3f3e60',
                }}
                polylineJourney={{
                  pickup: `${(journey.pickup || {}).lat},${
                    (journey.pickup || {}).lng
                  }`,
                  destination: `${(journey.destination || {}).lat},${
                    (journey.destination || {}).lng
                  }`,
                }}
                markers={[
                  ...(journey.pickup
                    ? [
                        {
                          name: 'Pickup',
                          icon: 'map-pin-red',
                          marker: {
                            coords: [journey.pickup.lat, journey.pickup.lng],
                          },
                        },
                      ]
                    : []),
                  ...(journey.destination
                    ? [
                        {
                          name: 'Destination',
                          icon: 'map-pin-green',
                          marker: {
                            coords: [
                              journey.destination.lat,
                              journey.destination.lng,
                            ],
                          },
                        },
                      ]
                    : []),
                ]}
                center={mapCenter}
                bounds={mapBounds}
              />
            </div>
          )}
          <div
            style={{
              flex: 1,
              overflowY: 'auto',
              overflowX: 'hidden',
              ...(showMap ? { padding: '0px 10px 20px 10px' } : {}),
              maxHeight:
                !loading &&
                (components.iconActions ||
                  components.buttons ||
                  components.importButtons)
                  ? '90%'
                  : undefined,
              padding: !isConfirmationDialog && 10,
              marginBottom: 10,
              height: '100%',
              maxHeight: '100%',
            }}
          >
            {components.bot}
            {loading ? <LoadingSheet /> : components.sections}
            {components.tabs}
            {components.tabBoxes}
            {components.headerTabs}
            {components.tabCards}
            {components.chatRoom}
          </div>
        </div>
      </DialogContent>
      {!loading &&
        (components.iconActions ||
          components.buttons ||
          components.importButtons) && (
          <div
            className={classes.dialogActions}
            style={{ padding: isConfirmationDialog && '8px 0px' }}
          >
            {!loading && components.importButtons}
            {!loading && (components.iconActions || components.buttons)}
          </div>
        )}
    </Dialog>
  );
}

export function DynamicConfirmDialogView({
  onClose,
  open,
  dynamicJSONContent,
  dialogUtils,
  ...props
}) {
  const classes = useStyles();
  const [deeplink, setDeepLink] = React.useState(props.deeplink);
  const [loading, setLoading] = React.useState(false);
  const components = useDynamicJSON({
    ...props,
    open,
    deeplink,
    setDeepLink,
    setDialogDeeplink: props.setDialogDeeplink,
    json: dynamicJSONContent,
    dialogUtils,
    setLoading,
    insideDialog: true,
    handleDeeplink: dialogUtils.current.handleDeeplink,
    miscHandlers: dialogUtils.current.miscHandlers,
    // formBody: dialogUtils.current.formBody,
    miscItems: dialogUtils.current.miscItems,
    dialogActionFunctionality: (data) => {
      data &&
        dialogUtils.current.onDone(
          (data || {}).refreshDeeplink ||
            ((data || {}).data || {}).refreshDeeplink
        );
    },
  });
  React.useEffect(() => setDeepLink(props.deeplink), [props.deeplink]);
  return (
    <Dialog
      disableEnforceFocus
      open={open}
      onClose={onClose}
      className={classes.dialog}
      maxWidth="sm"
    >
      <AppBar position="relative" elevation={0} className={classes.titlebar}>
        <Toolbar
          className={classes.dialogToolBar}
          style={
            (!components.title ? { justifyContent: 'flex-end' } : {},
            props.isMobile ? { minWidth: 'calc(100vw - 64px)' } : {})
          }
        >
          <Typography
            style={{ fontSize: '24px', color: '#505050', opacity: 1 }}
            noWrap={true}
            flex={1}
            spacing={1}
            className={classes.dialogTitle}
          >
            {components.title}
          </Typography>
          <IconButton
            edge="start"
            color="inherit"
            onClick={onClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <DialogContent
        style={{
          minHeight: 80,
        }}
      >
        {loading ? <LoadingSheet /> : components.sections}
      </DialogContent>
      {!loading && components.buttons && (
        <DialogActions
          className={classes.dialogActions}
          style={{ padding: 0, margin: 0 }}
        >
          {components.buttons}
          {/* <Button
          variant="contained"
          color="primary"
          style={{
            fontWeight:'bold',
            marginRight:10,
            background:
              'transparent linear-gradient(2deg, #fa4d5f 0%, #fa4d5f 100%) 0% 0% no-repeat padding-box',
            color: '#ffffff',
            paddingLeft: 10,
            paddingRight: 10,
            height: 40,
            maxWidth: 250,
            borderRadius: 5,
          }}
            onClick={onClose}
          >
            <div
              style={{
                    fontWeight:'bold',
                    whiteSpace: 'nowrap',
                    marginLeft: 5,
                    marginRight: 10,
                    fontSize: 16,
                    color: '#ffffff',
                    }}
              >
                  Cancel
              </div>

          </Button> */}
        </DialogActions>
      )}
    </Dialog>
  );
}

export function DynamicPromptView({
  onClose,
  open,
  rightSideBar,
  dialogUtils,
  ...props
}) {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="form-dialog-title"
      className={classes.dialog}
    >
      <AppBar position="relative" elevation={0} className={classes.titlebar}>
        <Toolbar
          className={classes.dialogToolBar}
          style={!SMPromptControl.title ? { justifyContent: 'flex-end' } : {}}
        >
          <Typography
            style={{ fontSize: '24px', color: '#505050', opacity: 1 }}
            noWrap={true}
            flex={1}
            spacing={1}
            className={classes.dialogTitle}
          >
            {SMPromptControl.title}
          </Typography>
          <IconButton
            edge="start"
            color="inherit"
            onClick={onClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <DialogContent style={{ minHeight: 150 }}>
        {SMPromptControl.content}
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        {SMPromptControl.actions}
      </DialogActions>
    </Dialog>
  );
}

export function DynamicChatDialogView({
  onClose,
  open,
  dynamicJSONContent,
  rightSideBar,
  dialogUtils,
  ...props
}) {
  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));
  const [loading, setLoading] = React.useState(false);
  const [deeplink, setDeepLink] = React.useState(props.deeplink || '');
  const components = useDynamicJSON({
    ...props,
    deeplink,
    setDeepLink,
    open,
    json: dynamicJSONContent,
    dialogUtils,
    setLoading,
    insideDialog: true,
    dialogActionFunctionality: (data) =>
      (data || {}).refreshDeeplink &&
      dialogUtils.current.onDone((data || {}).refreshDeeplink),
  });

  React.useEffect(() => setDeepLink(props.deeplink), [props.deeplink]);

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={onClose}
      aria-labelledby="form-dialog-title"
      className={classes.dialog}
      PaperProps={{
        style: {
          position: 'absolute',
          right: 0,
          bottom: 0,
          borderRadius: '12px',
          width: '548px',
          maxWidth: '548px',
        },
      }}
    >
      <AppBar
        position="relative"
        elevation={0}
        className={classes.titlebar}
        style={{
          background: '#3d65fe',
          width: '100%',
          height: '80px',
          borderBottom: '0.5px solid #8c8f92',
        }}
      >
        <Toolbar
          className={classes.dialogToolBar}
          style={{
            ...(!components.title ? { justifyContent: 'flex-end' } : {}),
            background: '#00000000',
            color: '#ffffff',
            border: 'None',
          }}
        >
          <Typography
            style={{ fontSize: '24px', opacity: 1, fontWeight: 'bold' }}
            noWrap={true}
            flex={1}
            spacing={1}
            className={classes.dialogTitle}
          >
            {!loading && components.title}
          </Typography>
          <IconButton
            edge="start"
            color="inherit"
            onClick={onClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <DialogContent
        className={classes.dialogContent}
        style={{
          padding: 0,
          background: '#f8fbff',
          width: '548px',
          maxWidth: '548px',
        }}
      >
        {loading ? <LoadingSheet /> : components.sections}
        {components.chatRoom}
      </DialogContent>
    </Dialog>
  );
}

export const DynamicDeleteDialogView = (props) => {
  const {
    onClose,
    selected,
    deleteDeeplink,
    handleDeeplink,
    dialogActionFunctionality,
  } = props;

  return (
    <Dialog open={true} onClose={onClose} fullWidth={true} maxWidth="sm">
      <DialogTitle style={{ fontWeight: 700 }}>{'Delete Item'}</DialogTitle>
      <DialogContent>
        <DialogContentText style={{ fontSize: '1.1rem' }}>
          Are you sure you want to delete {selected.length}{' '}
          {selected.length > 1 ? 'entries' : 'entry'}?
        </DialogContentText>
      </DialogContent>
      <DialogActions style={{ padding: '8px 16px' }}>
        <Button
          onClick={onClose}
          style={{
            marginLeft: 16,
          }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          style={{
            background:
              'transparent linear-gradient(180deg, #7467F0 0%, #2896E9 100%) 0% 0% no-repeat padding-box',
            color: 'white',
          }}
          onClick={() => {
            handleDeeplink(deleteDeeplink, 4).then((response) =>
              dialogActionFunctionality(response)
            );
          }}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default function DynamicScreen(props) {
  const { target, deeplink } = useParams();
  const { search: query, state: locationState } = useLocation();
  const [views, setViews] = React.useState({});
  const [currentTarget, setCurrentTarget] = React.useState(null);
  const history = useHistory();
  const [message, setMessage] = React.useState(null);
  const [headerTabs, setHeaderTabs] = React.useState(undefined);
  const [sidebarData, setSidebarData] = React.useState();
  const [menuComponent, setMenuComponent] = React.useState(undefined);
  const [menuOpen, setMenuOpen] = React.useState(false);
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [chatDialogOpen, setChatDialogOpen] = React.useState(false);
  const [locationDialogOpen, setLocationDialogOpen] = React.useState(false);
  const [promptOpen, setPromptOpen] = React.useState(false);
  const [dialogDeeplink, setDialogDeeplink] = React.useState('');
  const [confirmDialogDeeplink, setConfirmDialogDeeplink] = React.useState('');
  const [locationDialogDeeplink, setLocationDialogDeeplink] =
    React.useState('');
  const [dialogContent, setDialogContent] = React.useState(undefined);
  const [locationDialogContent, setLocationDialogContent] =
    React.useState(undefined);
  const dialogUtils = React.useRef({});
  const locationDialogUtils = React.useRef({});
  const location = useLocation();
  const classes = useStyles();
  let refreshScreenHandler = React.useRef({
    current: {
      refresher: () => {},
    },
  });
  const [isMobile, setIsMobile] = React.useState(false);
  const [confirmDialogOpen, setConfirmDialogOpen] = React.useState(false);
  const [confirmDialogContent, setConfirmDialogContent] =
    React.useState(undefined);
  const [errorBlock, setErrorBlock] = React.useState(null);
  //choose the screen size
  const handleResize = () => {
    if (window.innerWidth < 600) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };
  // create an event listener
  useEffect(() => {
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  });

  const navigate = React.useCallback(
    ({ url, message, historyAction, target }) => {
      if (message) {
        setMessage(message);
      }
      if (url) {
        const state = {
          refreshAt: +Date.now(), // adding this will force refresh due to useEffects dependency on locationState
          list: target === 'details' && views.list, // adding this retains list view, when details link is force refreshed
        };
        setCurrentTarget(target);
        if (historyAction === 'replace') {
          history.replace(url, state);
        } else {
          history.push(url, state);
        }
      }
      if (!url) {
        if (historyAction === 'back') {
          history.goBack();
        }
      }
    },
    [history, views.list]
  );

  const listViewFor = (view) => ({
    url: view.url && view.url.replace(/\/[^/]+$/, ''), // remove from last `/`
    target: view.target,
    _self: 'list',
  });

  const dialogOnClose = () => {
    setDialogOpen(false);
    setDialogDeeplink('');
    setDialogContent(undefined);
  };

  const chatDialogOnClose = () => {
    setChatDialogOpen(false);
    setDialogDeeplink('');
    setDialogContent(undefined);
  };

  const locationDialogOnClose = () => {
    setLocationDialogOpen(false);
    setDialogDeeplink('');
    setLocationDialogContent(undefined);
  };
  const confirmDialogOnClose = () => {
    setConfirmDialogOpen(false);
    setConfirmDialogDeeplink('');
    setConfirmDialogContent(undefined);
  };

  const promptOnClose = () => {
    setPromptOpen(false);
  };

  SMConfirmDialogControl.open = (
    { deeplink, dynamicJSON },
    apiType,
    formBody = {},
    miscHandlers = {},
    miscItems = {}
  ) => {
    dialogUtils.current.onDone = miscHandlers.doneCallback;
    dialogUtils.current.onCancel = miscHandlers.cancelCallback;
    dialogUtils.current.formBody = formBody;
    dialogUtils.current.miscItems = miscItems;
    dialogUtils.current.miscHandlers = miscHandlers;
    dialogUtils.current.close = confirmDialogOnClose;
    deeplink && setConfirmDialogDeeplink(deeplink);
    dynamicJSON && setDialogContent(dynamicJSON);
    setConfirmDialogOpen(true);
  };

  SMDIalogControl.open = (
    { deeplink, dynamicJSON },
    apiType,
    formBody,
    miscHandlers = {},
    miscAttributes = {},
    miscItems = {}
  ) => {
    try {
      dialogUtils.current.onDone = miscHandlers.doneCallback;
      dialogUtils.current.onCancel = miscHandlers.cancelCallback;
      dialogUtils.current.onError = miscHandlers.errorCallback;
      dialogUtils.current.handleDeeplink = miscHandlers.handleDeeplink;
      dialogUtils.current.showMap = miscAttributes.showMap;
      dialogUtils.current.isLarge = miscAttributes.isLarge;
      dialogUtils.current.isConfirmationDialog =
        miscAttributes.isConfirmationDialog;
      dialogUtils.current.miscHandlers = miscHandlers;
      dialogUtils.current.formBody = formBody;
      dialogUtils.current.miscItems = miscItems;
      deeplink && setDialogDeeplink(deeplink);
      dynamicJSON && setDialogContent(dynamicJSON);
      setDialogOpen(true);
    } catch (err) {
      console.log(err);
    }
  };

  SMChatDIalogControl.open = (
    { deeplink, dynamicJSON },
    apiType,
    formBody,
    miscHandlers = {}
  ) => {
    dialogUtils.current.onDone = miscHandlers.doneCallback;
    dialogUtils.current.onCancel = miscHandlers.cancelCallback;
    dialogUtils.current.onError = miscHandlers.errorCallback;
    dialogUtils.current.close = chatDialogOnClose;
    deeplink && setDialogDeeplink(deeplink);
    dynamicJSON && setDialogContent(dynamicJSON);
    setChatDialogOpen(true);
  };

  SMPromptControl.open = (title, content, actions) => {
    SMPromptControl.title = title || '';
    SMPromptControl.content = content || [];
    SMPromptControl.actions = actions || [];
    setPromptOpen(true);
  };

  SMDIalogControl.close = dialogOnClose;
  SMConfirmDialogControl.close = confirmDialogOnClose;

  SMLocationDIalogControl.open = (
    { deeplink, dynamicJSON },
    apiType,
    formBody,
    miscHandlers = {}
  ) => {
    locationDialogUtils.current.onDone =
      miscHandlers.doneCallback || (() => {});
    locationDialogUtils.current.onCancel =
      miscHandlers.cancelCallback || (() => {});
    locationDialogUtils.current.onError =
      miscHandlers.errorCallback || (() => {});
    locationDialogUtils.current.close = chatDialogOnClose;
    deeplink && setLocationDialogDeeplink(deeplink);
    dynamicJSON && setLocationDialogContent(dynamicJSON);
    setLocationDialogOpen(true);
  };
  SMPromptControl.close = promptOnClose;

  React.useEffect(() => {
    const view = {
      url: `/${deeplinkToURL(deeplink)}`,
      query,
      target,
      _self: target,
      refreshAt: locationState && locationState.refreshAt,
    };

    const viewHandlers = {
      page: () =>
        setViews({
          page: view,
        }),
      magicform: () =>
        setViews({
          magicform: view,
        }),
      magicscreen: () =>
        setViews({
          magicscreen: view,
        }),
      list: () =>
        setViews({
          list: { ...view, target: 'details' },
          details: { json: {} }, // empty view
        }),
      details: () =>
        setViews((views) => ({
          list:
            views.list ||
            (locationState && locationState.list) ||
            listViewFor(view),
          details: view,
        })),
      dialog: () =>
        setViews((views) => ({
          ...views,
          dialog: { ...view, target: currentTarget },
        })),
      reset: null, // TODO: implement breadcrumbs
      default: () => history.replace(`/${deeplink}`),
    };
    (viewHandlers[target] || viewHandlers.default)();
  }, [target, deeplink, query, history, locationState, currentTarget]);

  const closeSnackbar = () => setMessage(null);
  const defaults = { navigate };

  React.useEffect(() => {
    setSidebarData(undefined);
    setMenuComponent(undefined);
    setMenuOpen(false);
  }, [location]);

  return (
    <MainScreen
      {...{
        ...props,
        toolBarComponent: headerTabs,
        sidebarData,
        setSidebarData,
        rightSideBar: {
          menuOpen,
          menuComponent,
          setMenuOpen,
          setMenuComponent,
        },
        refreshScreenHandler,
      }}
    >
      <Grid
        container
        style={{
          height: '100%',
        }}
        className={
          isMobile || !!views.magicform
            ? classes.magicContainer
            : !!views.magicscreen
            ? classes.magicScreenContainer
            : classes.mainContainer
        }
      >
        {views.magicform && (
          <div
            style={{
              width: isMobile ? '100%' : '50%',
              margin: isMobile ? 0 : '10px auto',
            }}
          >
            <DynamicView
              {...views.magicform}
              {...{
                ...defaults,
                headerTabs,
                rootLevel: true,
                isMagicLinkContent: true,
                setHeaderTabs,
                sidebarData,
                setSidebarData,
                rightSideBar: {
                  setMenuComponent,
                  setMenuOpen,
                  menuOpen,
                },
                refreshHandler: (refreshHandler) => {
                  refreshScreenHandler.current.refresher = refreshHandler;
                },
              }}
              isMobile={isMobile}
              setMessage={setMessage}
              setErrorBlock={setErrorBlock}
              hideToolbar
            />
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'row-reverse',
              }}
            >
              <img
                src="https://pharmacyone-images.s3.ap-south-1.amazonaws.com/logo/1P-logo.png"
                style={{ height: '40px', marginLeft: 4 }}
              />
              <p>Powered By</p>
            </div>
          </div>
        )}
        {views.magicscreen && (
          <DynamicView
            {...views.magicscreen}
            {...{
              ...defaults,
              headerTabs,
              rootLevel: true,
              setHeaderTabs,
              sidebarData,
              setSidebarData,
              rightSideBar: {
                setMenuComponent,
                setMenuOpen,
                menuOpen,
              },
              refreshHandler: (refreshHandler) => {
                refreshScreenHandler.current.refresher = refreshHandler;
              },
            }}
            setMessage={setMessage}
            setErrorBlock={setErrorBlock}
            hideToolbar
          />
        )}
        {views.page && (
          <DynamicView
            {...views.page}
            {...{
              ...defaults,
              headerTabs,
              rootLevel: true,
              setHeaderTabs,
              sidebarData,
              setSidebarData,
              rightSideBar: {
                setMenuComponent,
                setMenuOpen,
                menuOpen,
              },
              refreshHandler: (refreshHandler) => {
                refreshScreenHandler.current.refresher = refreshHandler;
              },
            }}
            setMessage={setMessage}
            setErrorBlock={setErrorBlock}
            hideToolbar
            setDialogDeeplink={setDialogDeeplink}
          />
        )}
        <DynamicDialogView
          {...views.dialog}
          {...defaults}
          open={dialogOpen}
          onClose={dialogOnClose}
          deeplink={dialogDeeplink}
          dynamicJSONContent={dialogContent}
          dialogUtils={dialogUtils}
          setMessage={setMessage}
          setErrorBlock={setErrorBlock}
          rightSideBar={{
            setMenuComponent,
            setMenuOpen,
            menuOpen,
          }}
          setDialogDeeplink={setDialogDeeplink}
        />
        <DynamicConfirmDialogView
          open={confirmDialogOpen}
          onClose={confirmDialogOnClose}
          setMessage={setMessage}
          deeplink={confirmDialogDeeplink}
          dynamicJSONContent={confirmDialogContent}
          dialogUtils={dialogUtils}
          setErrorBlock={setErrorBlock}
          isMobile={isMobile}
          setDialogDeeplink={setDialogDeeplink}
        />
        <DynamicChatDialogView
          {...views.dialog}
          {...defaults}
          open={chatDialogOpen}
          onClose={chatDialogOnClose}
          deeplink={dialogDeeplink}
          dynamicJSONContent={dialogContent}
          dialogUtils={dialogUtils}
          setMessage={setMessage}
          rightSideBar={{
            setMenuComponent,
            setMenuOpen,
            menuOpen,
          }}
        />
        <LocationSelector
          {...views.dialog}
          {...defaults}
          open={locationDialogOpen}
          onClose={locationDialogOnClose}
          deeplink={locationDialogDeeplink}
          dynamicJSONContent={locationDialogContent}
          dialogUtils={locationDialogUtils}
          setMessage={setMessage}
          rightSideBar={{
            setMenuComponent,
            setMenuOpen,
            menuOpen,
          }}
        />
        <DynamicPromptView
          {...views.dialog}
          {...defaults}
          open={promptOpen}
          onClose={promptOnClose}
        />
      </Grid>
      {errorBlock ? <ErrorBlock error={errorBlock} /> : null}
      <Snackbar
        style={{ marginBottom: isMobile && '60px' }}
        open={!!message}
        autoHideDuration={6000}
        message={message}
        onClose={closeSnackbar}
        action={
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={closeSnackbar}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      />
    </MainScreen>
  );
}
